import { React, useState, useEffect } from "react";
import { geoCentroid } from "d3-geo";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  Annotation,
  ZoomableGroup
} from "react-simple-maps";

import allStates from "./allstates.json";
import Sidebar from "../Sidebar/Sidebar"
const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const markers = [
  { "markerOffset": 5, "name": "New York", "coordinates": [-74.0060, 40.7128] },
  { "markerOffset": 5, "name": "Los Angeles", "coordinates": [-118.2437, 34.0522] },
  { "markerOffset": 5, "name": "Chicago", "coordinates": [-87.6298, 41.8781] },
  { "markerOffset": 5, "name": "Miami", "coordinates": [-80.1917, 25.7617] },
  { "markerOffset": 5, "name": "Dallas", "coordinates": [-96.7969, 32.7767] },
  { "markerOffset": 5, "name": "Philadelphia", "coordinates": [-75.1652, 39.9526] },
  { "markerOffset": 5, "name": "Houston", "coordinates": [-95.3698, 29.7604] },
  { "markerOffset": 5, "name": "Atlanta", "coordinates": [-84.3880, 33.7490] },
  { "markerOffset": 5, "name": "Washington", "coordinates": [-77.0369, 38.9072] },
  { "markerOffset": 5, "name": "Boston", "coordinates": [-71.0589, 42.3601] },
  { "markerOffset": 5, "name": "Phoenix", "coordinates": [-112.0740, 33.4484] },
  { "markerOffset": 5, "name": "Seattle", "coordinates": [-122.3321, 47.6062] },
  { "markerOffset": 5, "name": "Detroit", "coordinates": [-83.0458, 42.3314] },
  { "markerOffset": 5, "name": "San Diego", "coordinates": [-117.1611, 32.7157] },
  { "markerOffset": 5, "name": "Minneapolis", "coordinates": [-93.2650, 44.9778] },
  { "markerOffset": 5, "name": "Tampa", "coordinates": [-82.4572, 27.9506] },
  { "markerOffset": 5, "name": "Denver", "coordinates": [-104.9903, 39.7392] },
  { "markerOffset": 5, "name": "Brooklyn", "coordinates": [-73.9442, 40.6782] },
  { "markerOffset": 5, "name": "Queens", "coordinates": [-73.7919, 40.7282] },
  { "markerOffset": 5, "name": "Baltimore", "coordinates": [-76.6122, 39.2904] },
  { "markerOffset": 5, "name": "Riverside", "coordinates": [-117.3962, 33.9533] },
  { "markerOffset": 5, "name": "Las Vegas", "coordinates": [-115.1398, 36.1699] },
  { "markerOffset": 5, "name": "Portland", "coordinates": [-122.6765, 45.5122] },
  { "markerOffset": 5, "name": "Sacramento", "coordinates": [-121.4944, 38.5816] },
  { "markerOffset": 5, "name": "Orlando", "coordinates": [-81.3792, 28.5383] },
  { "markerOffset": 5, "name": "Cleveland", "coordinates": [-81.6944, 41.4993] },
  { "markerOffset": 5, "name": "San Jose", "coordinates": [-121.8863, 37.3382] },
  { "markerOffset": 5, "name": "Pittsburgh", "coordinates": [-79.9959, 40.4406] },
  { "markerOffset": 5, "name": "Austin", "coordinates": [-97.7431, 30.2672] },
  { "markerOffset": 5, "name": "Cincinnati", "coordinates": [-84.5120, 39.1031] },
  { "markerOffset": 5, "name": "Manhattan", "coordinates": [-73.9712, 40.7831] },
  { "markerOffset": 5, "name": "Indianapolis", "coordinates": [-86.1581, 39.7684] },
  { "markerOffset": 5, "name": "Kansas City", "coordinates": [-94.5786, 39.0997] },
  { "markerOffset": 5, "name": "Columbus", "coordinates": [-82.9988, 39.9612] },
  { "markerOffset": 5, "name": "Charlotte", "coordinates": [-80.8431, 35.2271] },
  { "markerOffset": 5, "name": "Virginia Beach", "coordinates": [-75.9774, 36.8529] },
  { "markerOffset": 5, "name": "Bronx", "coordinates": [-73.8648, 40.8448] },
  { "markerOffset": 5, "name": "Milwaukee", "coordinates": [-87.9225, 43.0389] },
  { "markerOffset": 5, "name": "Providence", "coordinates": [-71.4128, 41.8240] },
  { "markerOffset": 5, "name": "Jacksonville", "coordinates": [-81.6557, 30.3322] },
  { "markerOffset": 5, "name": "Salt Lake City", "coordinates": [-111.8910, 40.7608] },
  { "markerOffset": 5, "name": "Nashville", "coordinates": [-86.7816, 36.1627] },
  { "markerOffset": 5, "name": "Richmond", "coordinates": [-77.4360, 37.5407] },
  { "markerOffset": 5, "name": "Memphis", "coordinates": [-90.0489, 35.1495] },
  { "markerOffset": 5, "name": "Raleigh", "coordinates": [-78.6382, 35.7796] },
  { "markerOffset": 5, "name": "Louisville", "coordinates": [-85.7585, 38.2527] },
  { "markerOffset": 5, "name": "New Orleans", "coordinates": [-90.0715, 29.9511] },
  { "markerOffset": 5, "name": "Oklahoma City", "coordinates": [-97.5164, 35.4676] },
  { "markerOffset": 5, "name": "Buffalo", "coordinates": [-78.8784, 42.8864] },
  { "markerOffset": 5, "name": "Bridgeport", "coordinates": [-73.2048, 41.1865] },
  { "markerOffset": 5, "name": "Hartford", "coordinates": [-72.6851, 41.7637] },
  { "markerOffset": 5, "name": "Fort Worth", "coordinates": [-97.3300, 32.7555] },
  { "markerOffset": 5, "name": "Tucson", "coordinates": [-110.9265, 32.2226] },
  { "markerOffset": 5, "name": "Omaha", "coordinates": [-95.9345, 41.2565] },
  { "markerOffset": 5, "name": "El Paso", "coordinates": [-106.4869, 31.7619] },
  { "markerOffset": 5, "name": "Honolulu", "coordinates": [-157.8583, 21.3069] },
  { "markerOffset": 5, "name": "McAllen", "coordinates": [-98.2300, 26.2034] },
  { "markerOffset": 5, "name": "Albuquerque", "coordinates": [-106.6056, 35.0844] },
  { "markerOffset": 5, "name": "Hempstead", "coordinates": [-73.6187, 40.7062] },
  { "markerOffset": 5, "name": "Sarasota", "coordinates": [-82.5307, 27.3364] },
  { "markerOffset": 5, "name": "Birmingham", "coordinates": [-86.8025, 33.5207] },
  { "markerOffset": 5, "name": "Dayton", "coordinates": [-84.1916, 39.7589] },
  { "markerOffset": 5, "name": "Fresno", "coordinates": [-119.7726, 36.7372] },
  { "markerOffset": 5, "name": "Rochester", "coordinates": [-77.6109, 43.1566] },
  { "markerOffset": 5, "name": "Allentown", "coordinates": [-75.4902, 40.6084] },
  { "markerOffset": 5, "name": "Tulsa", "coordinates": [-95.9928, 36.1540] },
  { "markerOffset": 5, "name": "Cape Coral", "coordinates": [-81.9498, 26.5629] },
  { "markerOffset": 5, "name": "Concord", "coordinates": [-71.5375, 43.2081] },
  { "markerOffset": 5, "name": "Colorado Springs", "coordinates": [-104.8214, 38.8339] },
  { "markerOffset": 5, "name": "Charleston", "coordinates": [-79.9311, 32.7765] },
  { "markerOffset": 5, "name": "Springfield", "coordinates": [-72.5898, 42.1015] },
  { "markerOffset": 5, "name": "Grand Rapids", "coordinates": [-85.6681, 42.9634] },
  { "markerOffset": 5, "name": "Albany", "coordinates": [-73.7562, 42.6526] },
  { "markerOffset": 5, "name": "Knoxville", "coordinates": [-83.9207, 35.9606] },
  { "markerOffset": 5, "name": "Mission Viejo", "coordinates": [-117.6715, 33.6000] },
  { "markerOffset": 5, "name": "Bakersfield", "coordinates": [-119.0187, 35.3733] },
  { "markerOffset": 5, "name": "Ogden", "coordinates": [-111.9738, 41.2230] },
  { "markerOffset": 5, "name": "Akron", "coordinates": [-81.5190, 41.0814] },
  { "markerOffset": 5, "name": "Baton Rouge", "coordinates": [-91.1871, 30.4515] },
  { "markerOffset": 5, "name": "Columbia", "coordinates": [-81.0348, 34.0007] },
  { "markerOffset": 5, "name": "New Haven", "coordinates": [-72.9279, 41.3082] },
  { "markerOffset": 5, "name": "Mesa", "coordinates": [-111.8315, 33.4152] },
  { "markerOffset": 5, "name": "Palm Bay", "coordinates": [-80.6626, 28.0345] },
  { "markerOffset": 5, "name": "Worcester", "coordinates": [-71.8023, 42.2626] },
  { "markerOffset": 5, "name": "Murrieta", "coordinates": [-117.2139, 33.5539] },
  { "markerOffset": 5, "name": "Wichita", "coordinates": [-97.3300, 37.6872] },
  { "markerOffset": 5, "name": "Toledo", "coordinates": [-83.5379, 41.6639] },
  { "markerOffset": 5, "name": "Greenville", "coordinates": [-82.3940, 34.8526] },
  { "markerOffset": 5, "name": "Brookhaven", "coordinates": [-73.1240, 40.7770] },
  { "markerOffset": 5, "name": "Staten Island", "coordinates": [-74.1502, 40.5795] },
  { "markerOffset": 5, "name": "Des Moines", "coordinates": [-93.6091, 41.6005] },
  { "markerOffset": 5, "name": "Long Beach", "coordinates": [-118.1937, 33.7701] },
  { "markerOffset": 5, "name": "Port St. Lucie", "coordinates": [-80.3503, 27.2730] },
  { "markerOffset": 5, "name": "Denton", "coordinates": [-97.1331, 33.2148] },
  { "markerOffset": 5, "name": "Madison", "coordinates": [-89.4012, 43.0731] },
  { "markerOffset": 5, "name": "Reno", "coordinates": [-119.8138, 39.5296] },
  { "markerOffset": 5, "name": "Harrisburg", "coordinates": [-76.8867, 40.2732] },
  { "markerOffset": 5, "name": "Little Rock", "coordinates": [-92.2896, 34.7465] },
  { "markerOffset": 5, "name": "Oakland", "coordinates": [-122.2711, 37.8044] },
  { "markerOffset": 5, "name": "Durham", "coordinates": [-78.8986, 35.9940] },
  { "markerOffset": 5, "name": "Winston-Salem", "coordinates": [-80.2442, 36.0999] },
  { "markerOffset": 5, "name": "Chattanooga", "coordinates": [-85.3097, 35.0456] },
  { "markerOffset": 5, "name": "Indio", "coordinates": [-116.2156, 33.7206] },
  { "markerOffset": 5, "name": "Palm Coast", "coordinates": [-81.2078, 29.5845] },
  { "markerOffset": 5, "name": "Spokane", "coordinates": [-117.4260, 47.6588] },
  { "markerOffset": 5, "name": "Syracuse", "coordinates": [-76.1474, 43.0481] },
  { "markerOffset": 5, "name": "Arlington", "coordinates": [-97.1081, 32.7357] },
  { "markerOffset": 5, "name": "Stockton", "coordinates": [-121.2908, 37.9577] },
  { "markerOffset": 5, "name": "Lancaster", "coordinates": [-118.1937, 34.6868] },
  { "markerOffset": 5, "name": "Poughkeepsie", "coordinates": [-73.9280, 41.7004] },
  { "markerOffset": 5, "name": "Augusta", "coordinates": [-81.9748, 33.4709] },
  { "markerOffset": 5, "name": "Boise", "coordinates": [-116.2023, 43.6150] },
  { "markerOffset": 5, "name": "Scranton", "coordinates": [-75.6624, 41.4080] },
  { "markerOffset": 5, "name": "Oxnard", "coordinates": [-119.1770, 34.1975] },
  { "markerOffset": 5, "name": "Modesto", "coordinates": [-120.9969, 37.6391] },
  { "markerOffset": 5, "name": "Aurora", "coordinates": [-104.8319, 39.7294] },
  { "markerOffset": 5, "name": "Kissimmee", "coordinates": [-81.4076, 28.2920] },
  { "markerOffset": 5, "name": "Youngstown", "coordinates": [-80.6495, 41.0998] },
  { "markerOffset": 5, "name": "Fayetteville", "coordinates": [-78.8784, 35.0527] },
  { "markerOffset": 5, "name": "Anaheim", "coordinates": [-117.9145, 33.8366] },
  { "markerOffset": 5, "name": "Pensacola", "coordinates": [-87.2169, 30.4213] },
  { "markerOffset": 5, "name": "Victorville", "coordinates": [-117.2927, 34.5361] },
  { "markerOffset": 5, "name": "Greensboro", "coordinates": [-79.7919, 36.0726] },
  { "markerOffset": 5, "name": "Corpus Christi", "coordinates": [-97.3964, 27.8006] },
  { "markerOffset": 5, "name": "Fort Wayne", "coordinates": [-85.1394, 41.0793] },
  { "markerOffset": 5, "name": "Flint", "coordinates": [-83.7430, 43.0125] },
  { "markerOffset": 5, "name": "Islip", "coordinates": [-73.2182, 40.7326] },
  { "markerOffset": 5, "name": "Jackson", "coordinates": [-90.1848, 32.2988] },
  { "markerOffset": 5, "name": "Lansing", "coordinates": [-84.5555, 42.7325] },
  { "markerOffset": 5, "name": "Lexington", "coordinates": [-84.5037, 38.0406] },
  { "markerOffset": 5, "name": "Henderson", "coordinates": [-115.0375, 36.0395] },
  { "markerOffset": 5, "name": "Ann Arbor", "coordinates": [-83.7430, 42.2808] },
  { "markerOffset": 5, "name": "Huntsville", "coordinates": [-86.5859, 34.7304] },
  { "markerOffset": 5, "name": "Mobile", "coordinates": [-88.0431, 30.6954] },
  { "markerOffset": 5, "name": "Asheville", "coordinates": [-82.5534, 35.5951] },
  { "markerOffset": 5, "name": "Fort Collins", "coordinates": [-105.0844, 40.5853] },
  { "markerOffset": 5, "name": "Lakeland", "coordinates": [-81.9498, 28.0395] },
  { "markerOffset": 5, "name": "Antioch", "coordinates": [-121.8058, 38.0049] },
  { "markerOffset": 5, "name": "Oyster Bay", "coordinates": [-73.5342, 40.7920] },
  { "markerOffset": 5, "name": "Trenton", "coordinates": [-74.7429, 40.2171] },
  { "markerOffset": 5, "name": "Lincoln", "coordinates": [-96.6817, 40.8136] },
  { "markerOffset": 5, "name": "Anchorage", "coordinates": [-149.9003, 61.2181] },
  { "markerOffset": 5, "name": "Irvine", "coordinates": [-117.7947, 33.6846] },
  { "markerOffset": 5, "name": "Plano", "coordinates": [-96.6989, 33.0198] },
  { "markerOffset": 5, "name": "Davenport", "coordinates": [-90.5776, 41.5236] },
  { "markerOffset": 5, "name": "Rockford", "coordinates": [-89.0937, 42.2711] },
  { "markerOffset": 5, "name": "Newark", "coordinates": [-74.1724, 40.7357] },
  { "markerOffset": 5, "name": "Shreveport", "coordinates": [-93.7502, 32.5252] },
  { "markerOffset": 5, "name": "South Bend", "coordinates": [-86.2500, 41.6764] },
  { "markerOffset": 5, "name": "Savannah", "coordinates": [-81.0998, 32.0809] },
  { "markerOffset": 5, "name": "Eugene", "coordinates": [-123.0868, 44.0521] },
  { "markerOffset": 5, "name": "Myrtle Beach", "coordinates": [-78.8867, 33.6891] },
  { "markerOffset": 5, "name": "Chula Vista", "coordinates": [-117.0842, 32.6401] },
  { "markerOffset": 5, "name": "Canton", "coordinates": [-81.3785, 40.7989] },
  { "markerOffset": 5, "name": "Lubbock", "coordinates": [-101.8552, 33.5779] },
  { "markerOffset": 5, "name": "Salem", "coordinates": [-123.0351, 44.9429] },
  { "markerOffset": 5, "name": "Winter Haven", "coordinates": [-81.7329, 28.0222] },
  { "markerOffset": 5, "name": "Lafayette", "coordinates": [-92.0198, 30.2241] },
  { "markerOffset": 5, "name": "Laredo", "coordinates": [-99.5075, 27.5306] },
  { "markerOffset": 5, "name": "Chandler", "coordinates": [-111.8412, 33.3062] },
  { "markerOffset": 5, "name": "Jersey City", "coordinates": [-74.0776, 40.7282] },
  { "markerOffset": 5, "name": "Scottsdale", "coordinates": [-111.9261, 33.4942] },
  { "markerOffset": 5, "name": "McKinney", "coordinates": [-96.6398, 33.1972] },
  { "markerOffset": 5, "name": "Killeen", "coordinates": [-97.7278, 31.1171] },
  { "markerOffset": 5, "name": "Tallahassee", "coordinates": [-84.2807, 30.4383] },
  { "markerOffset": 5, "name": "Peoria", "coordinates": [-89.5889, 40.6936] },
  { "markerOffset": 5, "name": "Wilmington", "coordinates": [-77.9447, 34.2257] },
  { "markerOffset": 5, "name": "Montgomery", "coordinates": [-86.2990, 32.3792] },
  { "markerOffset": 5, "name": "Gilbert", "coordinates": [-111.7890, 33.3528] },
  { "markerOffset": 5, "name": "Glendale", "coordinates": [-112.1859, 33.5387] },
  { "markerOffset": 5, "name": "Chesapeake", "coordinates": [-76.3122, 36.7682] },
  { "markerOffset": 5, "name": "Fremont", "coordinates": [-121.9886, 37.5485] },
  { "markerOffset": 5, "name": "Norfolk", "coordinates": [-76.2859, 36.8508] },
  { "markerOffset": 5, "name": "Barnstable", "coordinates": [-70.3002, 41.7003] },
  { "markerOffset": 5, "name": "Kennewick", "coordinates": [-119.1372, 46.2112] },
  { "markerOffset": 5, "name": "Irving", "coordinates": [-96.9489, 32.8140] },
  { "markerOffset": 5, "name": "Garland", "coordinates": [-96.6389, 32.9126] },
  { "markerOffset": 5, "name": "Visalia", "coordinates": [-119.2911, 36.3302] },
  { "markerOffset": 5, "name": "Atlantic City", "coordinates": [-74.4229, 39.3643] },
  { "markerOffset": 5, "name": "Paradise", "coordinates": [-115.1398, 36.0972] },
  { "markerOffset": 5, "name": "Nashua", "coordinates": [-71.4676, 42.7654] },
  { "markerOffset": 5, "name": "Hialeah", "coordinates": [-80.2781, 25.8576] },
  { "markerOffset": 5, "name": "Evansville", "coordinates": [-87.5711, 37.9716] },
  { "markerOffset": 5, "name": "Avondale", "coordinates": [-112.3496, 33.4356] },
  { "markerOffset": 5, "name": "Gulfport", "coordinates": [-89.0928, 30.3674] },
  { "markerOffset": 5, "name": "Appleton", "coordinates": [-88.4042, 44.2619] },
  { "markerOffset": 5, "name": "Bremerton", "coordinates": [-122.6325, 47.6062] },
  { "markerOffset": 5, "name": "Tacoma", "coordinates": [-122.4443, 47.2529] },
  { "markerOffset": 5, "name": "Hickory", "coordinates": [-81.3445, 35.7345] },
  { "markerOffset": 5, "name": "Kalamazoo", "coordinates": [-85.5872, 42.2917] },
  { "markerOffset": 5, "name": "San Bernardino", "coordinates": [-117.2898, 34.1083] },
  { "markerOffset": 5, "name": "College Station", "coordinates": [-96.3344, 30.6279] },
  { "markerOffset": 5, "name": "Roanoke", "coordinates": [-79.9414, 37.2710] },
  { "markerOffset": 5, "name": "Thousand Oaks", "coordinates": [-118.8376, 34.1706] },
  { "markerOffset": 5, "name": "Fargo", "coordinates": [-96.7898, 46.8772] },
  { "markerOffset": 5, "name": "Green Bay", "coordinates": [-88.0198, 44.5133] },
  { "markerOffset": 5, "name": "Spring Valley", "coordinates": [-115.2549, 36.1080] },
  { "markerOffset": 5, "name": "Amarillo", "coordinates": [-101.8313, 35.2210] },
  { "markerOffset": 5, "name": "Gainesville", "coordinates": [-82.3248, 29.6516] },
  { "markerOffset": 5, "name": "Huntington", "coordinates": [-82.4452, 38.4192] },
  { "markerOffset": 5, "name": "Olympia", "coordinates": [-122.9007, 47.0379] },
  { "markerOffset": 5, "name": "Yonkers", "coordinates": [-73.8816, 40.9312] },
  { "markerOffset": 5, "name": "Frisco", "coordinates": [-96.8236, 33.1507] },
  { "markerOffset": 5, "name": "Huntington Beach", "coordinates": [-118.0101, 33.6603] },
  { "markerOffset": 5, "name": "Deltona", "coordinates": [-81.2637, 28.9005] },
  { "markerOffset": 5, "name": "Tempe", "coordinates": [-111.9391, 33.4255] },
  { "markerOffset": 5, "name": "Overland Park", "coordinates": [-94.6708, 38.9822] },
  { "markerOffset": 5, "name": "Waco", "coordinates": [-97.1467, 31.5493] },
  { "markerOffset": 5, "name": "Sunrise Manor", "coordinates": [-115.0731, 36.2111] },
  { "markerOffset": 5, "name": "Waterbury", "coordinates": [-73.0515, 41.5582] },
  { "markerOffset": 5, "name": "Clarksville", "coordinates": [-87.3595, 36.5298] },
  { "markerOffset": 5, "name": "Cedar Rapids", "coordinates": [-91.6656, 41.9779] },
  { "markerOffset": 5, "name": "Sioux Falls", "coordinates": [-96.7311, 43.5446] },
  { "markerOffset": 5, "name": "Erie", "coordinates": [-80.0851, 42.1292] },
  { "markerOffset": 5, "name": "Ontario", "coordinates": [-117.6509, 34.0633] },
  { "markerOffset": 5, "name": "Hagerstown", "coordinates": [-77.7199, 39.6418] },
  { "markerOffset": 5, "name": "Spartanburg", "coordinates": [-81.9320, 34.9496] },
  { "markerOffset": 5, "name": "Fort Lauderdale", "coordinates": [-80.1373, 26.1224] },
  { "markerOffset": 5, "name": "Gastonia", "coordinates": [-81.1873, 35.2621] },
  { "markerOffset": 5, "name": "Murfreesboro", "coordinates": [-86.3903, 35.8456] },
  { "markerOffset": 5, "name": "Lorain", "coordinates": [-82.1824, 41.4528] },
  { "markerOffset": 5, "name": "High Point", "coordinates": [-79.9879, 35.9557] },
  { "markerOffset": 5, "name": "Newport News", "coordinates": [-76.4769, 37.0871] },
  { "markerOffset": 5, "name": "Rancho Cucamonga", "coordinates": [-117.5931, 34.1064] },
  { "markerOffset": 5, "name": "Hemet", "coordinates": [-116.9712, 33.7475] },
  { "markerOffset": 5, "name": "Oceanside", "coordinates": [-117.3795, 33.1959] },
  { "markerOffset": 5, "name": "Vallejo", "coordinates": [-122.2566, 38.1041] },
  { "markerOffset": 5, "name": "Pembroke Pines", "coordinates": [-80.2963, 26.0078] },
  { "markerOffset": 5, "name": "Medford", "coordinates": [-122.8756, 42.3265] },
  { "markerOffset": 5, "name": "Garden Grove", "coordinates": [-117.9414, 33.7743] },
  { "markerOffset": 5, "name": "Enterprise", "coordinates": [-115.5212, 36.028] },
  { "markerOffset": 5, "name": "Cary", "coordinates": [-78.7811, 35.7915] },
  { "markerOffset": 5, "name": "Ocala", "coordinates": [-82.1401, 29.1872] },
  { "markerOffset": 5, "name": "Marysville", "coordinates": [-122.1771, 48.0518] },
  { "markerOffset": 5, "name": "Corona", "coordinates": [-117.5664, 33.8753] },
  { "markerOffset": 5, "name": "Fredericksburg", "coordinates": [-77.5361, 38.3032] },
  { "markerOffset": 5, "name": "Manchester", "coordinates": [-71.4548, 42.9956] },
  { "markerOffset": 5, "name": "Champaign", "coordinates": [-88.2434, 40.1164] },
  { "markerOffset": 5, "name": "Hayward", "coordinates": [-122.0808, 37.6688] },
  { "markerOffset": 5, "name": "Lakewood", "coordinates": [-105.0844, 39.7047] },
  { "markerOffset": 5, "name": "Frederick", "coordinates": [-77.4105, 39.4143] },
  { "markerOffset": 5, "name": "Odessa", "coordinates": [-102.3676, 31.8457] },
  { "markerOffset": 5, "name": "Tuscaloosa", "coordinates": [-87.5622, 33.2098] },
  { "markerOffset": 5, "name": "Lake Charles", "coordinates": [-93.2174, 30.2266] },
  { "markerOffset": 5, "name": "Palmdale", "coordinates": [-118.1165, 34.5794] },
  { "markerOffset": 5, "name": "Warner Robins", "coordinates": [-83.6247, 32.613] },
  { "markerOffset": 5, "name": "Midland", "coordinates": [-102.0779, 31.9973] },
  { "markerOffset": 5, "name": "Hollywood", "coordinates": [-80.1495, 26.0112] },
  { "markerOffset": 5, "name": "Port Arthur", "coordinates": [-93.9708, 29.8849] },
  { "markerOffset": 5, "name": "Leesburg", "coordinates": [-77.5636, 39.1157] },
  { "markerOffset": 5, "name": "Muskegon", "coordinates": [-86.2484, 43.2342] },
  { "markerOffset": 5, "name": "Macon", "coordinates": [-83.6324, 32.8407] },
  { "markerOffset": 5, "name": "Sunnyvale", "coordinates": [-122.0364, 37.3688] },
  { "markerOffset": 5, "name": "Pomona", "coordinates": [-117.749, 34.0551] },
  { "markerOffset": 5, "name": "Escondido", "coordinates": [-117.0864, 33.1192] },
  { "markerOffset": 5, "name": "Pasadena", "coordinates": [-118.1445, 34.1478] },
  { "markerOffset": 5, "name": "Fairfield", "coordinates": [-122.0364, 38.2494] },
  { "markerOffset": 5, "name": "Naperville", "coordinates": [-88.162, 41.7508] },
  { "markerOffset": 5, "name": "Binghamton", "coordinates": [-75.9143, 42.0987] },
  { "markerOffset": 5, "name": "Bellevue", "coordinates": [-122.2007, 47.6104] },
  { "markerOffset": 5, "name": "Topeka", "coordinates": [-95.689, 39.0473] },
  { "markerOffset": 5, "name": "Elkhart", "coordinates": [-85.9767, 41.681] },
  { "markerOffset": 5, "name": "Beaumont", "coordinates": [-94.1266, 30.0802] },
  { "markerOffset": 5, "name": "Paterson", "coordinates": [-74.1718, 40.9168] },
  { "markerOffset": 5, "name": "Tyler", "coordinates": [-95.3011, 32.3513] },
  { "markerOffset": 5, "name": "Pueblo", "coordinates": [-104.6091, 38.2544] },
  { "markerOffset": 5, "name": "Yuma", "coordinates": [-114.591, 32.6927] },
  { "markerOffset": 5, "name": "Torrance", "coordinates": [-118.339, 33.835] },
  { "markerOffset": 5, "name": "Thornton", "coordinates": [-104.9719, 39.868] },
  { "markerOffset": 5, "name": "Surprise", "coordinates": [-112.3805, 33.67] },
  { "markerOffset": 5, "name": "Roseville", "coordinates": [-121.3081, 38.7521] },
  { "markerOffset": 5, "name": "Mesquite", "coordinates": [-96.5998, 32.7668] },
  { "markerOffset": 5, "name": "Grand Junction", "coordinates": [-108.5506, 39.0639] },
  { "markerOffset": 5, "name": "Fullerton", "coordinates": [-117.9243, 33.8704] },
  { "markerOffset": 5, "name": "Greeley", "coordinates": [-104.7091, 40.4233] },
  { "markerOffset": 5, "name": "Harlingen", "coordinates": [-97.6772, 26.1906] },
  { "markerOffset": 5, "name": "Las Cruces", "coordinates": [-106.7637, 32.3197] },
  { "markerOffset": 5, "name": "Hampton", "coordinates": [-76.3452, 37.0299] },
  { "markerOffset": 5, "name": "Bloomington", "coordinates": [-88.9937, 40.4842] },
  { "markerOffset": 5, "name": "Warren", "coordinates": [-83.0147, 42.5145] },
  { "markerOffset": 5, "name": "Yakima", "coordinates": [-120.5126, 46.6023] },
  { "markerOffset": 5, "name": "Coral Springs", "coordinates": [-80.2707, 26.2712] },
  { "markerOffset": 5, "name": "Round Rock", "coordinates": [-97.6544, 30.5253] },
  { "markerOffset": 5, "name": "Kent", "coordinates": [-122.2348, 47.3826] },
  { "markerOffset": 5, "name": "Sterling Heights", "coordinates": [-83.0106, 42.5803] },
  { "markerOffset": 5, "name": "Burlington", "coordinates": [-73.2125, 44.4759] },
  { "markerOffset": 5, "name": "Bellingham", "coordinates": [-122.4786, 48.7544] },
  { "markerOffset": 5, "name": "Stamford", "coordinates": [-73.5387, 41.0534] },
  { "markerOffset": 5, "name": "Johnson City", "coordinates": [-82.3535, 36.3134] },
  { "markerOffset": 5, "name": "Lynchburg", "coordinates": [-79.1422, 37.4138] },
  { "markerOffset": 5, "name": "Simi Valley", "coordinates": [-118.7815, 34.2694] },
  { "markerOffset": 5, "name": "Kenosha", "coordinates": [-87.8212, 42.5847] },
  { "markerOffset": 5, "name": "Fort Smith", "coordinates": [-94.3986, 35.3874] },
  { "markerOffset": 5, "name": "Norman", "coordinates": [-97.4395, 35.222] },
  { "markerOffset": 5, "name": "Boulder", "coordinates": [-105.2705, 40.015] },
  { "markerOffset": 5, "name": "Abilene", "coordinates": [-99.7473, 32.4487] },
  { "markerOffset": 5, "name": "Berkeley", "coordinates": [-122.2727, 37.8716] },
  { "markerOffset": 5, "name": "Redding", "coordinates": [-122.3917, 40.5865] },
  { "markerOffset": 5, "name": "Billings", "coordinates": [-108.5007, 45.7833] },
  { "markerOffset": 5, "name": "Yuba City", "coordinates": [-121.6169, 39.1404] },
  { "markerOffset": 5, "name": "Duluth", "coordinates": [-92.1251, 46.7867] },
  { "markerOffset": 5, "name": "Leominster", "coordinates": [-71.7598, 42.5251] },
  { "markerOffset": 5, "name": "Kingsport", "coordinates": [-82.5618, 36.5484] },
  { "markerOffset": 5, "name": "Rock Hill", "coordinates": [-81.0251, 34.9249] },
  { "markerOffset": 5, "name": "Gilroy", "coordinates": [-121.5683, 37.0058] },
  { "markerOffset": 5, "name": "Sugar Land", "coordinates": [-95.624, 29.6197] },
  { "markerOffset": 5, "name": "Iowa City", "coordinates": [-91.5302, 41.6611] },
  { "markerOffset": 5, "name": "Texas City", "coordinates": [-94.9027, 29.3838] },
  { "markerOffset": 5, "name": "Chico", "coordinates": [-121.8375, 39.7285] },
  { "markerOffset": 5, "name": "Saginaw", "coordinates": [-83.9508, 43.4195] },
  { "markerOffset": 5, "name": "Clearwater", "coordinates": [-82.7625, 27.9793] },
  { "markerOffset": 5, "name": "Smithtown", "coordinates": [-73.2166, 40.8559] },
  { "markerOffset": 5, "name": "Coeur d'Alene", "coordinates": [-116.7805, 47.6787] },
  { "markerOffset": 5, "name": "Seaside", "coordinates": [-121.8037, 36.6156] },
  { "markerOffset": 5, "name": "West Jordan", "coordinates": [-111.9823, 40.6097] },
  { "markerOffset": 5, "name": "North Charleston", "coordinates": [-79.9973, 32.9178] },
  { "markerOffset": 5, "name": "Carlsbad", "coordinates": [-117.3506, 33.1581] },
  { "markerOffset": 5, "name": "Temecula", "coordinates": [-117.1484, 33.4936] },
  { "markerOffset": 5, "name": "Clovis", "coordinates": [-119.6982, 36.8252] },
  { "markerOffset": 5, "name": "Meridian", "coordinates": [-116.3915, 43.6121] },
  { "markerOffset": 5, "name": "The Woodlands", "coordinates": [-95.5189, 30.1734] },
  { "markerOffset": 5, "name": "Costa Mesa", "coordinates": [-117.9187, 33.6633] },
  { "markerOffset": 5, "name": "Monroe", "coordinates": [-80.5499, 35.0406] },
  { "markerOffset": 5, "name": "Utica", "coordinates": [-75.2327, 43.1009] },
  { "markerOffset": 5, "name": "West Palm Beach", "coordinates": [-80.0534, 26.7193] },
  { "markerOffset": 5, "name": "Everett", "coordinates": [-122.2021, 47.979] },
  { "markerOffset": 5, "name": "El Centro", "coordinates": [-115.5631, 32.792] },
  { "markerOffset": 5, "name": "Downey", "coordinates": [-118.1332, 33.9401] },
  { "markerOffset": 5, "name": "Spring Hill", "coordinates": [-82.5368, 28.4762] },
  { "markerOffset": 5, "name": "Lowell", "coordinates": [-71.3162, 42.6334] },
  { "markerOffset": 5, "name": "Bend", "coordinates": [-121.3153, 44.0562] },
  { "markerOffset": 5, "name": "Lewisville", "coordinates": [-97.0117, 33.0462] },
  { "markerOffset": 5, "name": "Gresham", "coordinates": [-122.2021, 45.5023] },
  { "markerOffset": 5, "name": "Hillsboro", "coordinates": [-122.9356, 45.5229] },
  { "markerOffset": 5, "name": "League City", "coordinates": [-95.0957, 29.5075] },
  { "markerOffset": 5, "name": "Eau Claire", "coordinates": [-91.4985, 44.8113] },
  { "markerOffset": 5, "name": "Temple", "coordinates": [-97.3428, 31.0982] },
  { "markerOffset": 5, "name": "Turlock", "coordinates": [-120.8466, 37.4947] },
  { "markerOffset": 5, "name": "Sioux City", "coordinates": [-96.4059, 42.499] },
  { "markerOffset": 5, "name": "Highlands Ranch", "coordinates": [-104.9708, 39.5539] },
  { "markerOffset": 5, "name": "Wichita Falls", "coordinates": [-98.4934, 33.9137] },
  { "markerOffset": 5, "name": "Norwalk", "coordinates": [-118.0817, 33.9069] },
  { "markerOffset": 5, "name": "Manteca", "coordinates": [-121.2128, 37.7974] },
  { "markerOffset": 5, "name": "El Cajon", "coordinates": [-116.9605, 32.7948] },
  { "markerOffset": 5, "name": "Longmont", "coordinates": [-105.1019, 40.1672] },
  { "markerOffset": 5, "name": "Burbank", "coordinates": [-118.3259, 34.1808] },
  { "markerOffset": 5, "name": "Renton", "coordinates": [-122.2165, 47.4829] },
  { "markerOffset": 5, "name": "Logan", "coordinates": [-111.8338, 41.7369] },
  { "markerOffset": 5, "name": "Vacaville", "coordinates": [-121.9877, 38.3566] },
  { "markerOffset": 5, "name": "Carmel", "coordinates": [-86.118, 39.97837] },
  { "markerOffset": 5, "name": "Edison", "coordinates": [-74.4121, 40.5187] },
  { "markerOffset": 5, "name": "San Angelo", "coordinates": [-100.4397, 31.4638] },
  { "markerOffset": 5, "name": "La Crosse", "coordinates": [-91.2396, 43.8014] },
  { "markerOffset": 5, "name": "Charlottesville", "coordinates": [-78.4767, 38.0293] },
  { "markerOffset": 5, "name": "Longview", "coordinates": [-94.742, 32.5007] },
  { "markerOffset": 5, "name": "Idaho Falls", "coordinates": [-112.0391, 43.4916] },
  { "markerOffset": 5, "name": "Woodbridge", "coordinates": [-74.2846, 40.5549] },
  { "markerOffset": 5, "name": "Tracy", "coordinates": [-121.4252, 37.7397] },
  { "markerOffset": 5, "name": "Bismarck", "coordinates": [-100.7837, 46.8083] },
  { "markerOffset": 5, "name": "Orem", "coordinates": [-111.6841, 40.2969] },
  { "markerOffset": 5, "name": "Quincy", "coordinates": [-71.0023, 42.2529] },
  { "markerOffset": 5, "name": "Germantown", "coordinates": [-89.8101, 35.0868] },
  { "markerOffset": 5, "name": "Santa Monica", "coordinates": [-118.4965, 34.0232] },
  { "markerOffset": 5, "name": "San Leandro", "coordinates": [-122.1561, 37.7249] },
  { "markerOffset": 5, "name": "Citrus Heights", "coordinates": [-121.281, 38.6831] },
  { "markerOffset": 5, "name": "State College", "coordinates": [-77.861, 40.7934] },
  { "markerOffset": 5, "name": "Hawthorne", "coordinates": [-118.3526, 33.9143] },
  { "markerOffset": 5, "name": "Clifton", "coordinates": [-74.1638, 40.8584] },
  { "markerOffset": 5, "name": "Alhambra", "coordinates": [-118.1367, 34.0953] },
  { "markerOffset": 5, "name": "Mountain View", "coordinates": [-122.0838, 37.3861] },
  { "markerOffset": 5, "name": "Silver Spring", "coordinates": [-77.0261, 38.9907] },
  { "markerOffset": 5, "name": "Somerville", "coordinates": [-71.1014, 42.3876] },
  { "markerOffset": 5, "name": "Lawrence", "coordinates": [-71.1631, 42.707] },
  { "markerOffset": 5, "name": "Deerfield Beach", "coordinates": [-80.1514, 26.3184] },
  { "markerOffset": 5, "name": "Cheyenne", "coordinates": [-104.8203, 41.14] },
  { "markerOffset": 5, "name": "Tustin", "coordinates": [-117.8262, 33.742] },
  { "markerOffset": 5, "name": "Lebanon", "coordinates": [-86.2911, 36.202] },
  { "markerOffset": 5, "name": "Watsonville", "coordinates": [-121.7569, 36.9102] },
  { "markerOffset": 5, "name": "Centreville", "coordinates": [-77.466, 38.8338] },
  { "markerOffset": 5, "name": "Camden", "coordinates": [-75.1196, 39.9259] },
  { "markerOffset": 5, "name": "Evanston", "coordinates": [-87.6847, 42.0451] },
  { "markerOffset": 5, "name": "Pawtucket", "coordinates": [-71.3826, 41.8787] },
  { "markerOffset": 5, "name": "Lynwood", "coordinates": [-118.212, 33.9303] },
  { "markerOffset": 5, "name": "Passaic", "coordinates": [-74.124, 40.8568] },
  { "markerOffset": 5, "name": "Gaithersburg", "coordinates": [-77.2207, 39.1434] },
  { "markerOffset": 5, "name": "Union City", "coordinates": [-74.2632, 40.7374] },
  { "markerOffset": 5, "name": "Mount Vernon", "coordinates": [-77.0876, 38.7223] },
  { "markerOffset": 5, "name": "Redondo Beach", "coordinates": [-118.387, 33.8492] },
  { "markerOffset": 5, "name": "Schenectady", "coordinates": [-73.9396, 42.8166] },
  { "markerOffset": 5, "name": "Bayonne", "coordinates": [-74.1143, 40.6687] },
  { "markerOffset": 5, "name": "East Orange", "coordinates": [-74.2049, 40.7673] },
  { "markerOffset": 5, "name": "Brentwood", "coordinates": [-73.2454, 40.7812] },
  { "markerOffset": 5, "name": "Malden", "coordinates": [-71.0662, 42.4251] },
  { "markerOffset": 5, "name": "Monterey Park", "coordinates": [-118.1228, 34.0625] },
  { "markerOffset": 5, "name": "Cupertino", "coordinates": [-122.0322, 37.323] },
  { "markerOffset": 5, "name": "La Mesa", "coordinates": [-117.0221, 32.7678] },
  { "markerOffset": 5, "name": "Brookline", "coordinates": [-71.1202, 42.3317] },
  { "markerOffset": 5, "name": "Carson City", "coordinates": [-119.7674, 39.1638] },
  { "markerOffset": 5, "name": "Middletown", "coordinates": [-84.3963, 39.5151] },
  { "markerOffset": 5, "name": "White Plains", "coordinates": [-73.7629, 41.033] },
  { "markerOffset": 5, "name": "Jefferson City", "coordinates": [-92.1735, 38.5767] },
  { "markerOffset": 5, "name": "Huntington Park", "coordinates": [-118.2168, 33.98] },
  { "markerOffset": 5, "name": "Kendale Lakes", "coordinates": [-80.3712, 25.7076] },
  { "markerOffset": 5, "name": "Ithaca", "coordinates": [-76.5019, 42.443, 27.7956] },
  { "markerOffset": 5, "name": "Berwyn", "coordinates": [-87.7937, 41.8506] },
  { "markerOffset": 5, "name": "Hoboken", "coordinates": [-74.0324, 40.744] },
  { "markerOffset": 5, "name": "West New York", "coordinates": [-74.0121, 40.787] },
  { "markerOffset": 5, "name": "Helena", "coordinates": [-112.0361, 46.5927] },
  { "markerOffset": 5, "name": "Oak Park", "coordinates": [-87.7845, 41.885] },
  { "markerOffset": 5, "name": "Levittown", "coordinates": [-73.5111, 40.7294] },
  { "markerOffset": 5, "name": "Aliso Viejo", "coordinates": [-117.7259, 33.5677] },
  { "markerOffset": 5, "name": "Wheaton", "coordinates": [-88.107, 41.8661] },
  { "markerOffset": 5, "name": "North Bethesda", "coordinates": [-77.118, 39.0501] },
  { "markerOffset": 5, "name": "Cerritos", "coordinates": [-118.0648, 33.8583] },
  { "markerOffset": 5, "name": "Bloomfield", "coordinates": [-74.1881, 40.8057] },
  { "markerOffset": 5, "name": "Covina", "coordinates": [-117.8893, 34.0908] },
  { "markerOffset": 5, "name": "Hackensack", "coordinates": [-74.0435, 40.8859] },
  { "markerOffset": 5, "name": "Cleveland Heights", "coordinates": [-81.5615, 41.5201] },
  { "markerOffset": 5, "name": "Bell Gardens", "coordinates": [-118.1515, 33.9695] },
  { "markerOffset": 5, "name": "Woonsocket", "coordinates": [-71.4914, 42.0029] },
  { "markerOffset": 5, "name": "Wilkes-Barre", "coordinates": [-75.8784, 41.2454] },
  { "markerOffset": 5, "name": "Teaneck", "coordinates": [-74.0118, 40.8929] },
  { "markerOffset": 5, "name": "Montclair", "coordinates": [-74.209, 40.8259] },
  { "markerOffset": 5, "name": "Annapolis", "coordinates": [-76.4922, 38.9784] },
  { "markerOffset": 5, "name": "Waipahu", "coordinates": [-158.0089, 21.3867] },
  { "markerOffset": 5, "name": "Culver City", "coordinates": [-118.3965, 34.0219] },
  { "markerOffset": 5, "name": "Frankfort", "coordinates": [-84.8966, 38.2009] },
  { "markerOffset": 5, "name": "Fort Lee", "coordinates": [-73.9736, 40.8509] },
  { "markerOffset": 5, "name": "Lake Worth", "coordinates": [-80.055, 26.6145] },
  { "markerOffset": 5, "name": "East Meadow", "coordinates": [-73.5594, 40.7144] },
  { "markerOffset": 5, "name": "Mission Bend", "coordinates": [-95.6815, 29.6938] },
  { "markerOffset": 5, "name": "South Miami Heights", "coordinates": [-80.35, 25.5877] },
  { "markerOffset": 5, "name": "Aventura", "coordinates": [-80.1451, 25.9565] },
  { "markerOffset": 5, "name": "West Hollywood", "coordinates": [-118.3717, 34.09] },
  { "markerOffset": 5, "name": "Kearns", "coordinates": [-111.9773, 40.6596] },
  { "markerOffset": 5, "name": "Watertown Town", "coordinates": [-71.1828, 42.37] },
  { "markerOffset": 5, "name": "Elmont", "coordinates": [-73.7061, 40.7038] },
  { "markerOffset": 5, "name": "Temple City", "coordinates": [-118.0578, 34.1024] },
  { "markerOffset": 5, "name": "Westmont", "coordinates": [-87.9756, 41.7886] },
  { "markerOffset": 5, "name": "Manhattan Beach", "coordinates": [-118.4085, 33.885] },
  { "markerOffset": 5, "name": "Norristown", "coordinates": [-75.3802, 40.1215] },
  { "markerOffset": 5, "name": "Beverly Hills", "coordinates": [-118.394, 34.07] },
  { "markerOffset": 5, "name": "Foster City", "coordinates": [-122.2711, 37.5585] },
  { "markerOffset": 5, "name": "Chester", "coordinates": [-75.3716, 39.8498] },
  { "markerOffset": 5, "name": "Glendale Heights", "coordinates": [-88.0766, 41.9213] },
  { "markerOffset": 5, "name": "Mount Lebanon", "coordinates": [-80.042, 40.3749] },
  { "markerOffset": 5, "name": "Juneau", "coordinates": [-134.4197, 58.3019] },
  { "markerOffset": 5, "name": "College Park", "coordinates": [-84.3963, 33.6534] },
  { "markerOffset": 5, "name": "Eastpointe", "coordinates": [-82.9452, 42.4684] },
  { "markerOffset": 5, "name": "Uniondale", "coordinates": [-73.5876, 40.7081] },
  { "markerOffset": 5, "name": "Burlingame", "coordinates": [-122.3641, 37.5841] },
  { "markerOffset": 5, "name": "Sterling", "coordinates": [-77.4273, 39.0017] },
  { "markerOffset": 5, "name": "Long Branch", "coordinates": [-74.0003, 40.3043] },
  { "markerOffset": 5, "name": "East Palo Alto", "coordinates": [-122.1274, 37.4688] },
  { "markerOffset": 5, "name": "Bergenfield", "coordinates": [-73.9974, 40.9276] },
  { "markerOffset": 5, "name": "Easton", "coordinates": [-75.2207, 40.6884] },
  { "markerOffset": 5, "name": "Cliffside Park", "coordinates": [-73.9885, 40.8214] },
  { "markerOffset": 5, "name": "Decatur", "coordinates": [-84.2941, 33.7748] },
  { "markerOffset": 5, "name": "Laurel", "coordinates": [-76.8483, 39.0993] },
  { "markerOffset": 5, "name": "El Cerrito", "coordinates": [-122.304, 37.9159] },
  { "markerOffset": 5, "name": "Palm Springs", "coordinates": [-116.5453, 33.8303] },
  { "markerOffset": 5, "name": "South Bradenton", "coordinates": [-82.5658, 27.4541] },
  { "markerOffset": 5, "name": "Herndon", "coordinates": [-77.3941, 38.9696] },
  { "markerOffset": 5, "name": "Baldwin", "coordinates": [-73.608, 40.6631] },
  { "markerOffset": 5, "name": "Suitland", "coordinates": [-76.9328, 38.843] },
  { "markerOffset": 5, "name": "Woodlawn", "coordinates": [-76.8254, 39.3111] },
  { "markerOffset": 5, "name": "Ashland", "coordinates": [-82.6157, 38.4784] },
  { "markerOffset": 5, "name": "Oak Ridge", "coordinates": [-84.2696, 36.0104] },
  { "markerOffset": 5, "name": "Blue Island", "coordinates": [-87.6809, 41.6574] },
  { "markerOffset": 5, "name": "Hayesville", "coordinates": [-83.8047, 34.9343] },
  { "markerOffset": 5, "name": "Massapequa", "coordinates": [-73.4707, 40.6815] },
  { "markerOffset": 5, "name": "Sunny Isles Beach", "coordinates": [-80.1236, 25.9421] },
  { "markerOffset": 5, "name": "Columbia Heights", "coordinates": [-93.2608, 45.0434] },
  { "markerOffset": 5, "name": "Harrison", "coordinates": [-74.1546, 40.7438] },
  { "markerOffset": 5, "name": "Central Falls", "coordinates": [-71.3885, 41.8905] },
  { "markerOffset": 5, "name": "Morristown", "coordinates": [-74.4785, 40.7968] },
  { "markerOffset": 5, "name": "Hermosa Beach", "coordinates": [-118.3965, 33.8611] },
  { "markerOffset": 5, "name": "Evergreen Park", "coordinates": [-87.7028, 41.7201] },
  { "markerOffset": 5, "name": "Point Pleasant", "coordinates": [-74.0718, 40.0799] },
  { "markerOffset": 5, "name": "North Amityville", "coordinates": [-73.4179, 40.7061] },
  { "markerOffset": 5, "name": "Rutherford", "coordinates": [-74.1068, 40.8271] },
  { "markerOffset": 5, "name": "Hyattsville", "coordinates": [-76.9548, 38.9526] },
  { "markerOffset": 5, "name": "Lansdale", "coordinates": [-75.2833, 40.2415] },
  { "markerOffset": 5, "name": "Clayton", "coordinates": [-90.349, 38.6428] },
  { "markerOffset": 5, "name": "Artesia", "coordinates": [-118.0804, 33.8658] },
  { "markerOffset": 5, "name": "South Orange Village", "coordinates": [-74.2618, 40.7474] },
  { "markerOffset": 5, "name": "Bull Run", "coordinates": [-77.4762, 38.7967] },
  { "markerOffset": 5, "name": "East Riverdale", "coordinates": [-76.9164, 38.967] },
  { "markerOffset": 5, "name": "Stanford", "coordinates": [-122.167, 37.4241] },
  { "markerOffset": 5, "name": "Walnut Park", "coordinates": [-118.221, 33.9695] },
  { "markerOffset": 5, "name": "East Rancho Dominguez", "coordinates": [-118.2017, 33.8889] },
  { "markerOffset": 5, "name": "North New Hyde Park", "coordinates": [-73.6869, 40.7325] },
  { "markerOffset": 5, "name": "Pierre", "coordinates": [-100.351, 44.3683] },
  { "markerOffset": 5, "name": "Collingswood", "coordinates": [-75.076, 39.9189] },
  { "markerOffset": 5, "name": "Highland Park", "coordinates": [-87.8001, 42.1817] },
  { "markerOffset": 5, "name": "Grover Beach", "coordinates": [-120.6216, 35.1216] },
  { "markerOffset": 5, "name": "Coatesville", "coordinates": [-75.8164, 39.9834] },
  { "markerOffset": 5, "name": "Ridgefield Park", "coordinates": [-74.0143, 40.8572] },
  { "markerOffset": 5, "name": "Clarkston", "coordinates": [-83.4206, 42.7084] },
  { "markerOffset": 5, "name": "Red Bank", "coordinates": [-74.0672, 40.3471] },
  { "markerOffset": 5, "name": "Alum Rock", "coordinates": [-121.8193, 37.3699] },
  { "markerOffset": 5, "name": "Piedmont", "coordinates": [-122.2364, 37.8245] },
  { "markerOffset": 5, "name": "Summit", "coordinates": [-74.3637, 40.7168] },
  { "markerOffset": 5, "name": "White City", "coordinates": [-122.8406, 42.439] },
  { "markerOffset": 5, "name": "Inwood", "coordinates": [-73.7478, 40.7541] },
  { "markerOffset": 5, "name": "Brookdale", "coordinates": [-122.0009, 37.4304] },
  { "markerOffset": 5, "name": "Westgate", "coordinates": [-82.35, 28.3475] },
  { "markerOffset": 5, "name": "Wood-Ridge", "coordinates": [-74.0842, 40.8534] },
  { "markerOffset": 5, "name": "Plainedge", "coordinates": [-73.4691, 40.6974] },
  { "markerOffset": 5, "name": "Caldwell", "coordinates": [-74.2765, 40.8408] },
  { "markerOffset": 5, "name": "Boyes Hot Springs", "coordinates": [-122.4909, 38.3089] },
  { "markerOffset": 5, "name": "Fanwood", "coordinates": [-74.3857, 40.6413] },
  { "markerOffset": 5, "name": "Calumet Park", "coordinates": [-87.655, 41.6648] },
  { "markerOffset": 5, "name": "Williston Park", "coordinates": [-73.6469, 40.756] },
  { "markerOffset": 5, "name": "Nyack", "coordinates": [-73.9151, 41.0907] },
  { "markerOffset": 5, "name": "Ridley Park", "coordinates": [-75.3247, 39.8759] },
  { "markerOffset": 5, "name": "Castroville", "coordinates": [-121.7444, 36.7682] },
  { "markerOffset": 5, "name": "Lewisburg", "coordinates": [-86.7737, 35.4496] },
  { "markerOffset": 5, "name": "Media", "coordinates": [-75.3882, 39.9131] },
  { "markerOffset": 5, "name": "Cutler", "coordinates": [-80.412, 25.6159] },
  { "markerOffset": 5, "name": "Twin Lakes", "coordinates": [-88.2518, 42.5337] },
  { "markerOffset": 5, "name": "Turtle Creek", "coordinates": [-79.8237, 40.4078] },
  { "markerOffset": 5, "name": "Mechanicville", "coordinates": [-73.6909, 42.9026] },
  { "markerOffset": 5, "name": "Boca Raton", "coordinates": [-80.1248, 26.3683] },
  { "markerOffset": 5, "name": "Beaverton", "coordinates": [-122.8037, 45.4871] },
  { "markerOffset": 5, "name": "Rio Rancho", "coordinates": [-106.6884, 35.2328] },
  { "markerOffset": 5, "name": "Brockton", "coordinates": [-71.0184, 42.0834] },
  { "markerOffset": 5, "name": "Bowling Green", "coordinates": [-86.4454, 36.9903] },
  { "markerOffset": 5, "name": "Plantation", "coordinates": [-80.2482, 26.1276] },
  { "markerOffset": 5, "name": "Menifee", "coordinates": [-117.1859, 33.6971] },
  { "markerOffset": 5, "name": "Hanford", "coordinates": [-119.6457, 36.3275] },
  { "markerOffset": 5, "name": "Edmond", "coordinates": [-97.4781, 35.6574] },
  { "markerOffset": 5, "name": "Livonia", "coordinates": [-83.3527, 42.3684] },
  { "markerOffset": 5, "name": "Lawton", "coordinates": [-98.3959, 34.6085] },
  { "markerOffset": 5, "name": "Missoula", "coordinates": [-113.9916, 46.8721] },
  { "markerOffset": 5, "name": "Auburn", "coordinates": [-85.4808, 32.6099] },
  { "markerOffset": 5, "name": "Slidell", "coordinates": [-89.7828, 30.2752] },
  { "markerOffset": 5, "name": "Rapid City", "coordinates": [-103.231, 44.0805] },
  { "markerOffset": 5, "name": "Terre Haute", "coordinates": [-87.3722, 39.4659] },
  { "markerOffset": 5, "name": "Toms River", "coordinates": [-74.195, 39.9599] },
  { "markerOffset": 5, "name": "Suffolk", "coordinates": [-76.5875, 36.7282] },
  { "markerOffset": 5, "name": "Blacksburg", "coordinates": [-80.4134, 37.2296] },
  { "markerOffset": 5, "name": "Carson", "coordinates": [-118.281, 33.8322] },
  { "markerOffset": 5, "name": "Conroe", "coordinates": [-95.4551, 30.3119] },
  { "markerOffset": 5, "name": "Livermore", "coordinates": [-121.768, 37.6819] },
  { "markerOffset": 5, "name": "New Braunfels", "coordinates": [-98.1292, 29.703] },
  { "markerOffset": 5, "name": "Fall River", "coordinates": [-71.1551, 41.7015] },
  { "markerOffset": 5, "name": "Muncie", "coordinates": [-85.382, 40.1934] },
  { "markerOffset": 5, "name": "Fort Myers", "coordinates": [-81.7887, 26.6406] },
  { "markerOffset": 5, "name": "Dalton", "coordinates": [-84.9719, 34.7698] },
  { "markerOffset": 5, "name": "Anderson", "coordinates": [-85.6803, 40.1053] },
  { "markerOffset": 5, "name": "Redwood City", "coordinates": [-122.2307, 37.4852] },
  { "markerOffset": 5, "name": "Largo", "coordinates": [-82.7873, 27.9094] },
  { "markerOffset": 5, "name": "Newport Beach", "coordinates": [-117.9289, 33.6189] },
  { "markerOffset": 5, "name": "Joplin", "coordinates": [-94.5133, 37.0842] },
  { "markerOffset": 5, "name": "Zephyrhills", "coordinates": [-82.1801, 28.2336] },
  { "markerOffset": 5, "name": "Flagstaff", "coordinates": [-111.6513, 35.1981] },
  { "markerOffset": 5, "name": "St. Augustine", "coordinates": [-81.3258, 29.9012] },
  { "markerOffset": 5, "name": "Pleasanton", "coordinates": [-121.8747, 37.6624] },
  { "markerOffset": 5, "name": "Williamsburg", "coordinates": [-76.7075, 37.2707] },
  { "markerOffset": 5, "name": "Farmington Hills", "coordinates": [-83.3677, 42.498] },
  { "markerOffset": 5, "name": "Hattiesburg", "coordinates": [-89.2903, 31.3271] },
  { "markerOffset": 5, "name": "Valdosta", "coordinates": [-83.2781, 30.8327] },
  { "markerOffset": 5, "name": "Buckeye", "coordinates": [-112.5838, 33.3703] },
  { "markerOffset": 5, "name": "Kokomo", "coordinates": [-86.118, 40.4864] },
  { "markerOffset": 5, "name": "Loveland", "coordinates": [-105.075, 40.3978] },
  { "markerOffset": 5, "name": "Boynton Beach", "coordinates": [-80.0905, 26.5253] },
  { "markerOffset": 5, "name": "Jonesboro", "coordinates": [-90.7043, 35.8211] },
  { "markerOffset": 5, "name": "Texarkana", "coordinates": [-93.9927, 33.4251] },
  { "markerOffset": 5, "name": "Elizabethtown", "coordinates": [-85.8662, 37.703] },
  { "markerOffset": 5, "name": "Upland", "coordinates": [-117.6484, 34.1109] },
  { "markerOffset": 5, "name": "Baytown", "coordinates": [-94.9774, 29.7605] },
  { "markerOffset": 5, "name": "San Ramon", "coordinates": [-121.978, 37.7799] },
  { "markerOffset": 5, "name": "Oshkosh", "coordinates": [-88.5415, 44.0207] },
  { "markerOffset": 5, "name": "Hammond", "coordinates": [-87.5, 41.5834] },
  { "markerOffset": 5, "name": "Pasco", "coordinates": [-119.1006, 46.2396] },
  { "markerOffset": 5, "name": "Conway", "coordinates": [-92.4518, 35.0887] },
  { "markerOffset": 5, "name": "Altoona", "coordinates": [-78.3947, 40.5187] },
  { "markerOffset": 5, "name": "Gary", "coordinates": [-87.3464, 41.5934] },
  { "markerOffset": 5, "name": "Arlington Heights", "coordinates": [-87.9795, 42.0884] },
  { "markerOffset": 5, "name": "Owensboro", "coordinates": [-87.1117, 37.7742] },
  { "markerOffset": 5, "name": "Hilton Head Island", "coordinates": [-80.7526, 32.2163] },
  { "markerOffset": 5, "name": "Framingham", "coordinates": [-71.4162, 42.2793] },
  { "markerOffset": 5, "name": "Wausau", "coordinates": [-89.6301, 44.9591] },
  { "markerOffset": 5, "name": "Apple Valley", "coordinates": [-117.1859, 34.5] },
  { "markerOffset": 5, "name": "Schaumburg", "coordinates": [-88.0834, 42.0334] },
  { "markerOffset": 5, "name": "Pocatello", "coordinates": [-112.444, 42.8713] },
  { "markerOffset": 5, "name": "Morgantown", "coordinates": [-79.9563, 39.6295] },
  { "markerOffset": 5, "name": "Woodbury", "coordinates": [-92.9589, 44.9239] },
  { "markerOffset": 5, "name": "Dothan", "coordinates": [-85.3936, 31.2232] },
  { "markerOffset": 5, "name": "Harrisonburg", "coordinates": [-78.8689, 38.4496] },
  { "markerOffset": 5, "name": "Wenatchee", "coordinates": [-120.3103, 47.4235] },
  { "markerOffset": 5, "name": "Waukesha", "coordinates": [-88.2315, 43.0117] },
  { "markerOffset": 5, "name": "Redmond", "coordinates": [-122.1215, 47.6694] },
  { "markerOffset": 5, "name": "Sumter", "coordinates": [-80.3492, 33.9204] },
  { "markerOffset": 5, "name": "Cherry Hill", "coordinates": [-74.9918, 39.9349] },
  { "markerOffset": 5, "name": "Sherman", "coordinates": [-96.6089, 33.6357] },
  { "markerOffset": 5, "name": "Broomfield", "coordinates": [-105.1088, 39.9205] },
  { "markerOffset": 5, "name": "El Paso de Robles", "coordinates": [-120.6615, 35.63] },
  { "markerOffset": 5, "name": "Walnut Creek", "coordinates": [-122.065, 37.905] },
  { "markerOffset": 5, "name": "Lehi", "coordinates": [-111.8508, 40.3916] },
  { "markerOffset": 5, "name": "Sheboygan", "coordinates": [-87.7145, 43.7508] },
  { "markerOffset": 5, "name": "Delray Beach", "coordinates": [-80.0526, 26.4615] },
  { "markerOffset": 5, "name": "Homestead", "coordinates": [-80.4821, 25.4687] },
  { "markerOffset": 5, "name": "Lake Elsinore", "coordinates": [-117.3273, 33.6681] },
  { "markerOffset": 5, "name": "Daytona Beach", "coordinates": [-81.0228, 29.2108] },
  { "markerOffset": 5, "name": "Rocklin", "coordinates": [-121.2358, 38.7881] },
  { "markerOffset": 5, "name": "Rogers", "coordinates": [-94.1185, 36.3313] },
  { "markerOffset": 5, "name": "Castle Rock", "coordinates": [-104.8561, 39.3722] },
  { "markerOffset": 5, "name": "Rockville", "coordinates": [-77.1514, 39.0834] },
  { "markerOffset": 5, "name": "Ames", "coordinates": [-93.6429, 42.0347] },
  { "markerOffset": 5, "name": "Dubuque", "coordinates": [-90.6646, 42.5006] },
  { "markerOffset": 5, "name": "Saratoga Springs", "coordinates": [-73.786, 43.0809] },
  { "markerOffset": 5, "name": "Casper", "coordinates": [-106.3131, 42.8502] },
  { "markerOffset": 5, "name": "Yorba Linda", "coordinates": [-117.795, 33.89] },
  { "markerOffset": 5, "name": "Palatine", "coordinates": [-88.0365, 42.1103] },
  { "markerOffset": 5, "name": "Corvallis", "coordinates": [-123.262, 44.5646] },
  { "markerOffset": 5, "name": "Ankeny", "coordinates": [-93.6001, 41.7297] },
  { "markerOffset": 5, "name": "Alpharetta", "coordinates": [-84.2962, 34.0754] },
  { "markerOffset": 5, "name": "Eagan", "coordinates": [-93.1669, 44.8187] },
  { "markerOffset": 5, "name": "Shawnee", "coordinates": [-94.7151, 39.0228] },
  { "markerOffset": 5, "name": "Jupiter", "coordinates": [-80.1094, 26.9342] },
  { "markerOffset": 5, "name": "Carbondale", "coordinates": [-89.2167, 37.726] },
  { "markerOffset": 5, "name": "Tulare", "coordinates": [-119.3422, 36.2077] },
  { "markerOffset": 5, "name": "Pflugerville", "coordinates": [-97.6209, 30.4394] },
  { "markerOffset": 5, "name": "Eden Prairie", "coordinates": [-93.4708, 44.8547] },
  { "markerOffset": 5, "name": "Great Falls", "coordinates": [-111.2891, 47.5024] },
  { "markerOffset": 5, "name": "Grand Forks", "coordinates": [-97.0586, 47.9253] },
  { "markerOffset": 5, "name": "Eastvale", "coordinates": [-117.5664, 33.9525] },
  { "markerOffset": 5, "name": "Chapel Hill", "coordinates": [-79.0558, 35.9132] },
  { "markerOffset": 5, "name": "Rocky Mount", "coordinates": [-77.7905, 35.9382] },
  { "markerOffset": 5, "name": "Beloit", "coordinates": [-89.0318, 42.5083] },
  { "markerOffset": 5, "name": "Fairbanks", "coordinates": [-147.725, 64.838] },
  { "markerOffset": 5, "name": "Johnstown", "coordinates": [-105.0713, 40.3428] },
  { "markerOffset": 5, "name": "West Hartford", "coordinates": [-72.7626, 41.7611] },
  { "markerOffset": 5, "name": "Coon Rapids", "coordinates": [-93.3032, 45.1781] },
  { "markerOffset": 5, "name": "Mankato", "coordinates": [-94.0101, 44.1634] },
  { "markerOffset": 5, "name": "Encinitas", "coordinates": [-117.2434, 33.0369] },
  { "markerOffset": 5, "name": "Parkersburg", "coordinates": [-81.5374, 39.2667] },
  { "markerOffset": 5, "name": "Waltham", "coordinates": [-71.2356, 42.3765] },
  { "markerOffset": 5, "name": "Palm Harbor", "coordinates": [-82.7411, 28.077] },
  { "markerOffset": 5, "name": "Sebring", "coordinates": [-81.3544, 27.4951] },
  { "markerOffset": 5, "name": "San Luis Obispo", "coordinates": [-120.6596, 35.2828] },
  { "markerOffset": 5, "name": "Reston", "coordinates": [-77.357, 38.9586] },
  { "markerOffset": 5, "name": "Burnsville", "coordinates": [-93.2777, 44.7677] },
  { "markerOffset": 5, "name": "Marietta", "coordinates": [-84.5086, 33.9532] },
  { "markerOffset": 5, "name": "Gadsden", "coordinates": [-86.0066, 34.0143] },
  { "markerOffset": 5, "name": "Taylor", "coordinates": [-83.2696, 42.2409] },
  { "markerOffset": 5, "name": "Staunton", "coordinates": [-79.0526, 38.159] },
  { "markerOffset": 5, "name": "Pontiac", "coordinates": [-83.291, 42.6389] },
  { "markerOffset": 5, "name": "Royal Oak", "coordinates": [-83.1446, 42.4895] },
  { "markerOffset": 5, "name": "Des Plaines", "coordinates": [-87.8812, 42.0334] },
  { "markerOffset": 5, "name": "Bowie", "coordinates": [-76.7791, 38.9572] },
  { "markerOffset": 5, "name": "Wesley Chapel", "coordinates": [-82.355, 28.322] },
  { "markerOffset": 5, "name": "Huntersville", "coordinates": [-80.8503, 35.4107] },
  { "markerOffset": 5, "name": "Beckley", "coordinates": [-81.1882, 37.7786] },
  { "markerOffset": 5, "name": "Titusville", "coordinates": [-80.8076, 28.6122] },
  { "markerOffset": 5, "name": "Walla Walla", "coordinates": [-118.3324, 46.0646] },
  { "markerOffset": 5, "name": "Bozeman", "coordinates": [-111.0447, 45.677] },
  { "markerOffset": 5, "name": "East Stroudsburg", "coordinates": [-75.1618, 41.0018] },
  { "markerOffset": 5, "name": "Goldsboro", "coordinates": [-77.9928, 35.3823] },
  { "markerOffset": 5, "name": "Shoreline", "coordinates": [-122.3411, 47.7556] },
  { "markerOffset": 5, "name": "Piscataway", "coordinates": [-74.4802, 40.5515] },
  { "markerOffset": 5, "name": "Lake Havasu City", "coordinates": [-114.3224, 34.47] },
  { "markerOffset": 5, "name": "Smyrna", "coordinates": [-86.5144, 35.9828] },
  { "markerOffset": 5, "name": "Cape Girardeau", "coordinates": [-89.5295, 37.3059] },
  { "markerOffset": 5, "name": "Grants Pass", "coordinates": [-123.3316, 42.4381] },
  { "markerOffset": 5, "name": "Southaven", "coordinates": [-90.0023, 34.9889] },
  { "markerOffset": 5, "name": "Pittsfield", "coordinates": [-73.2454, 42.4501] },
  { "markerOffset": 5, "name": "Twin Falls", "coordinates": [-114.4604, 42.562] },
  { "markerOffset": 5, "name": "Grapevine", "coordinates": [-97.0781, 32.9343] },
  { "markerOffset": 5, "name": "Bentonville", "coordinates": [-94.2088, 36.3729] },
  { "markerOffset": 5, "name": "Normal", "coordinates": [-88.9731, 40.5142] },
  { "markerOffset": 5, "name": "Arroyo Grande", "coordinates": [-120.5884, 35.1186] },
  { "markerOffset": 5, "name": "Brunswick", "coordinates": [-81.8232, 41.2381] },
  { "markerOffset": 5, "name": "Wayne", "coordinates": [-75.3879, 40.9481] },
  { "markerOffset": 5, "name": "Yucaipa", "coordinates": [-117.0431, 34.0336] },
  { "markerOffset": 5, "name": "Williamsport", "coordinates": [-77.0075, 41.2493] },
  { "markerOffset": 5, "name": "Pinellas Park", "coordinates": [-82.7073, 27.8428] },
  { "markerOffset": 5, "name": "Apopka", "coordinates": [-81.5326, 28.6934] },
  { "markerOffset": 5, "name": "Grand Island", "coordinates": [-98.3442, 40.9264] },
  { "markerOffset": 5, "name": "Watertown", "coordinates": [-73.1185, 41.2745] },
  { "markerOffset": 5, "name": "Wylie", "coordinates": [-96.5933, 33.0151] },
  { "markerOffset": 5, "name": "Lacey", "coordinates": [-122.8116, 47.0343] },
  { "markerOffset": 5, "name": "Summerville", "coordinates": [-80.1756, 32.9656] },
  { "markerOffset": 5, "name": "Parsippany-Troy Hills", "coordinates": [-74.4042, 40.8653] },
  { "markerOffset": 5, "name": "Lompoc", "coordinates": [-120.4579, 34.6496] },
  { "markerOffset": 5, "name": "Sierra Vista", "coordinates": [-110.9659, 31.5455] },
  { "markerOffset": 5, "name": "Glendora", "coordinates": [-117.8641, 34.1361] },
  { "markerOffset": 5, "name": "New Bern", "coordinates": [-77.0726, 35.1085] },
  { "markerOffset": 5, "name": "Farmington", "coordinates": [-108.2187, 36.7477] },
  { "markerOffset": 5, "name": "Hinesville", "coordinates": [-81.5968, 31.8469] },
  { "markerOffset": 5, "name": "West Lafayette", "coordinates": [-86.9292, 40.4501] },
  { "markerOffset": 5, "name": "Queen Creek", "coordinates": [-111.6343, 33.2487] },
  { "markerOffset": 5, "name": "Traverse City", "coordinates": [-85.6166, 44.7631] },
  { "markerOffset": 5, "name": "Stillwater", "coordinates": [-97.0586, 36.1156] },
  { "markerOffset": 5, "name": "Cookeville", "coordinates": [-85.5016, 36.1628] },
  { "markerOffset": 5, "name": "Bullhead City", "coordinates": [-114.5286, 35.1359] },
  { "markerOffset": 5, "name": "Ashburn", "coordinates": [-77.4875, 39.0438] },
  { "markerOffset": 5, "name": "Morehead City", "coordinates": [-76.7475, 34.7262] },
  { "markerOffset": 5, "name": "Minot", "coordinates": [-101.2951, 48.2325] },
  { "markerOffset": 5, "name": "Paducah", "coordinates": [-88.6436, 37.0834] },
  { "markerOffset": 5, "name": "Kyle", "coordinates": [-97.8858, 29.9891] },
  { "markerOffset": 5, "name": "Jeffersonville", "coordinates": [-85.7372, 38.2776] },
  { "markerOffset": 5, "name": "Winder", "coordinates": [-83.7209, 33.9922] },
  { "markerOffset": 5, "name": "Cumberland", "coordinates": [-78.7643, 39.6532] },
  { "markerOffset": 5, "name": "Rancho Santa Margarita", "coordinates": [-117.598, 33.6409] },
  { "markerOffset": 5, "name": "Beavercreek", "coordinates": [-84.0633, 39.7092] },
  { "markerOffset": 5, "name": "McLean", "coordinates": [-77.1711, 38.9339] },
  { "markerOffset": 5, "name": "East Providence", "coordinates": [-71.356, 41.8137] },
  { "markerOffset": 5, "name": "Mentor", "coordinates": [-81.3327, 41.6662] },
  { "markerOffset": 5, "name": "Danville", "coordinates": [-79.395, 36.5859] },
  { "markerOffset": 5, "name": "Keller", "coordinates": [-97.2293, 32.9342] },
  { "markerOffset": 5, "name": "Sandusky", "coordinates": [-82.7156, 41.4489] },
  { "markerOffset": 5, "name": "Kingman", "coordinates": [-114.053, 35.1894] },
  { "markerOffset": 5, "name": "Biloxi", "coordinates": [-88.8854, 30.396] },
  { "markerOffset": 5, "name": "Weatherford", "coordinates": [-97.7608, 32.7596] },
  { "markerOffset": 5, "name": "Roseburg", "coordinates": [-123.3409, 43.2165] },
  { "markerOffset": 5, "name": "Leavenworth", "coordinates": [-95.0099, 39.321] },
  { "markerOffset": 5, "name": "Fort Pierce", "coordinates": [-80.3256, 27.4467] },
  { "markerOffset": 5, "name": "Pinehurst", "coordinates": [-79.4695, 35.1934] },
  { "markerOffset": 5, "name": "Pearl City", "coordinates": [-157.9658, 21.3972] },
  { "markerOffset": 5, "name": "Tupelo", "coordinates": [-88.7034, 34.2576] },
  { "markerOffset": 5, "name": "Pine Bluff", "coordinates": [-92.0032, 34.2284] },
  { "markerOffset": 5, "name": "Hilo", "coordinates": [-155.09, 19.6994] },
  { "markerOffset": 5, "name": "Lufkin", "coordinates": [-94.7291, 31.3382] },
  { "markerOffset": 5, "name": "Wallingford", "coordinates": [-72.8244, 41.457] },
  { "markerOffset": 5, "name": "Webster", "coordinates": [-82.328, 28.4134] },
  { "markerOffset": 5, "name": "Eureka", "coordinates": [-124.1637, 40.8021] },
  { "markerOffset": 5, "name": "Lombard", "coordinates": [-88.0073, 41.880] },
  { "markerOffset": 5, "name": "Prescott", "coordinates": [-112.4683, 34.5403] },
  { "markerOffset": 5, "name": "Sayreville", "coordinates": [-74.353, 40.4593] },
  { "markerOffset": 5, "name": "Desert Hot Springs", "coordinates": [-116.4956, 33.9611] },
  { "markerOffset": 5, "name": "Peachtree Corners", "coordinates": [-84.2215, 33.9699] },
  { "markerOffset": 5, "name": "Adrian", "coordinates": [-84.0372, 41.8976] },
  { "markerOffset": 5, "name": "Goose Creek", "coordinates": [-80.0326, 32.981] },
  { "markerOffset": 5, "name": "Westfield", "coordinates": [-72.7493, 42.1251] },
  { "markerOffset": 5, "name": "Klamath Falls", "coordinates": [-121.7817, 42.2249] },
  { "markerOffset": 5, "name": "Brea", "coordinates": [-117.9001, 33.9167] },
  { "markerOffset": 5, "name": "Stevens Point", "coordinates": [-89.5732, 44.5236] },
  { "markerOffset": 5, "name": "Egg Harbor", "coordinates": [-74.8019, 39.3871] },
  { "markerOffset": 5, "name": "Hutchinson", "coordinates": [-97.9298, 38.0608] },
  { "markerOffset": 5, "name": "Puyallup", "coordinates": [-122.2924, 47.1854] },
  { "markerOffset": 5, "name": "Urbana", "coordinates": [-88.1976, 40.1106] },
  { "markerOffset": 5, "name": "Beverly", "coordinates": [-70.88, 42.5584] },
  { "markerOffset": 5, "name": "Hobbs", "coordinates": [-103.1326, 32.7026] },
  { "markerOffset": 5, "name": "McMinnville", "coordinates": [-123.1918, 45.2101] },
  { "markerOffset": 5, "name": "Grove City", "coordinates": [-83.0922, 39.8815] },
  { "markerOffset": 5, "name": "Wentzville", "coordinates": [-90.8529, 38.8114] },
  { "markerOffset": 5, "name": "North Brunswick", "coordinates": [-74.4653, 40.4525] },
  { "markerOffset": 5, "name": "Weslaco", "coordinates": [-97.9875, 26.1595] },
  { "markerOffset": 5, "name": "Zanesville", "coordinates": [-82.0132, 39.9403] },
  { "markerOffset": 5, "name": "Catonsville", "coordinates": [-76.7452, 39.2864] },
  { "markerOffset": 5, "name": "Coppell", "coordinates": [-97.015, 32.9638] },
  { "markerOffset": 5, "name": "Moline", "coordinates": [-90.5151, 41.5067] },
  { "markerOffset": 5, "name": "Delaware", "coordinates": [-83.0672, 40.2987] },
  { "markerOffset": 5, "name": "Manassas", "coordinates": [-77.4753, 38.7509] },
  { "markerOffset": 5, "name": "Westerville", "coordinates": [-82.882, 40.1262] },
  { "markerOffset": 5, "name": "Spanish Fork", "coordinates": [-111.6547, 40.1149] },
  { "markerOffset": 5, "name": "Pottsville", "coordinates": [-76.1976, 40.6859] },
  { "markerOffset": 5, "name": "Buffalo Grove", "coordinates": [-87.9648, 42.1666] },
  { "markerOffset": 5, "name": "Torrington", "coordinates": [-73.1216, 41.8003] },
  { "markerOffset": 5, "name": "Cedar City", "coordinates": [-113.055, 37.6775] },
  { "markerOffset": 5, "name": "Crystal Lake", "coordinates": [-88.3306, 42.2411] },
  { "markerOffset": 5, "name": "Lake Oswego", "coordinates": [-122.6706, 45.4207] },
  { "markerOffset": 5, "name": "Muskogee", "coordinates": [-95.3831, 35.7479] },
  { "markerOffset": 5, "name": "Issaquah", "coordinates": [-122.0291, 47.5325] },
  { "markerOffset": 5, "name": "Streamwood", "coordinates": [-88.1784, 42.0256] },
  { "markerOffset": 5, "name": "Kalispell", "coordinates": [-114.3215, 48.2025] },
  { "markerOffset": 5, "name": "Mooresville", "coordinates": [-80.8209, 35.5851] },
  { "markerOffset": 5, "name": "Crestview", "coordinates": [-86.5704, 30.7635] },
  { "markerOffset": 5, "name": "Clinton", "coordinates": [-73.7322, 41.2803] },
  { "markerOffset": 5, "name": "Moses Lake", "coordinates": [-119.287, 47.1301] },
  { "markerOffset": 5, "name": "Groton", "coordinates": [-71.9601, 41.3508] },
  { "markerOffset": 5, "name": "Pleasant Grove", "coordinates": [-111.7385, 40.3641] },
  { "markerOffset": 5, "name": "Menomonee Falls", "coordinates": [-88.0985, 43.1789] },
  { "markerOffset": 5, "name": "Kailua", "coordinates": [-157.7494, 21.402] },
  { "markerOffset": 5, "name": "Pahrump", "coordinates": [-116.0321, 36.2083] },
  { "markerOffset": 5, "name": "Rock Island", "coordinates": [-90.5787, 41.5095] },
  { "markerOffset": 5, "name": "Evans", "coordinates": [-104.722, 40.3763] },
  { "markerOffset": 5, "name": "Commack", "coordinates": [-73.2822, 40.8448] },
  { "markerOffset": 5, "name": "Yorktown", "coordinates": [-73.7926, 41.2737] },
  { "markerOffset": 5, "name": "Gillette", "coordinates": [-105.5072, 44.297] },
  { "markerOffset": 5, "name": "Tooele", "coordinates": [-112.2983, 40.5308] },
  { "markerOffset": 5, "name": "Prattville", "coordinates": [-86.4525, 32.464] },
  { "markerOffset": 5, "name": "New City", "coordinates": [-73.983, 41.1476] },
  { "markerOffset": 5, "name": "Owings Mills", "coordinates": [-76.7809, 39.4196] },
  { "markerOffset": 5, "name": "La Porte", "coordinates": [-118.0579, 33.8464] },
  { "markerOffset": 5, "name": "DeLand", "coordinates": [-81.3009, 29.0283] },
  { "markerOffset": 5, "name": "Merrillville", "coordinates": [-87.3381, 41.4828] },
  { "markerOffset": 5, "name": "Pullman", "coordinates": [-117.1683, 46.7313] },
  { "markerOffset": 5, "name": "Nacogdoches", "coordinates": [-94.6586, 31.6035] },
  { "markerOffset": 5, "name": "North Ridgeville", "coordinates": [-82.0282, 41.3898] },
  { "markerOffset": 5, "name": "Russellville", "coordinates": [-93.1338, 35.2785] },
  { "markerOffset": 5, "name": "Grass Valley", "coordinates": [-121.0586, 39.2191] },
  { "markerOffset": 5, "name": "Kennesaw", "coordinates": [-84.5969, 34.0234] },
  { "markerOffset": 5, "name": "Laramie", "coordinates": [-105.5911, 41.3114] },
  { "markerOffset": 5, "name": "Fairborn", "coordinates": [-84.0197, 39.8209] },
  { "markerOffset": 5, "name": "Cottonwood Heights", "coordinates": [-111.8287, 40.6183] },
  { "markerOffset": 5, "name": "Mason", "coordinates": [-84.3022, 39.3601] },
  { "markerOffset": 5, "name": "Galesburg", "coordinates": [-90.3712, 40.9478] },
  { "markerOffset": 5, "name": "San Dimas", "coordinates": [-117.8067, 34.1067] },
  { "markerOffset": 5, "name": "Midlothian", "coordinates": [-77.6487, 37.4365] },
  { "markerOffset": 5, "name": "Alamogordo", "coordinates": [-105.9603, 32.8994] },
  { "markerOffset": 5, "name": "Pikesville", "coordinates": [-76.7075, 39.3742] },
  { "markerOffset": 5, "name": "Greer", "coordinates": [-82.2271, 34.9388] },
  { "markerOffset": 5, "name": "Springville", "coordinates": [-111.6126, 40.1652] },
  { "markerOffset": 5, "name": "Fairmont", "coordinates": [-80.1439, 39.4851] },
  { "markerOffset": 5, "name": "Ridgecrest", "coordinates": [-117.6761, 35.6225] },
  { "markerOffset": 5, "name": "Spanaway", "coordinates": [-122.4251, 47.0958] },
  { "markerOffset": 5, "name": "Starkville", "coordinates": [-88.8184, 33.4504] },
  { "markerOffset": 5, "name": "Princeton", "coordinates": [-74.6672, 40.3573] },
  { "markerOffset": 5, "name": "Bethel Park", "coordinates": [-80.0287, 40.3282] },
  { "markerOffset": 5, "name": "Smithfield", "coordinates": [-71.5201, 41.9181] },
  { "markerOffset": 5, "name": "East Lake", "coordinates": [-82.7165, 28.839] },
  { "markerOffset": 5, "name": "Coos Bay", "coordinates": [-124.2243, 43.3665] },
  { "markerOffset": 5, "name": "Clearfield", "coordinates": [-77.8136, 40.9873] },
  { "markerOffset": 5, "name": "Martinsville", "coordinates": [-79.8725, 36.6915] },
  { "markerOffset": 5, "name": "South Riding", "coordinates": [-77.5263, 38.9171] },
  { "markerOffset": 5, "name": "Key West", "coordinates": [-81.7806, 24.5557] },
  { "markerOffset": 5, "name": "Kahului", "coordinates": [-156.4584, 20.8895] },
  { "markerOffset": 5, "name": "Eldersburg", "coordinates": [-76.9419, 39.4036] },
  { "markerOffset": 5, "name": "Nicholasville", "coordinates": [-84.5541, 37.8806] },
  { "markerOffset": 5, "name": "Lawrenceville", "coordinates": [-84.124, 33.9562] },
  { "markerOffset": 5, "name": "Kerrville", "coordinates": [-99.1393, 30.0474] },
  { "markerOffset": 5, "name": "Crown Point", "coordinates": [-87.3653, 41.4167] },
  { "markerOffset": 5, "name": "Lakeside", "coordinates": [-117.0309, 32.8573] },
  { "markerOffset": 5, "name": "Fuquay-Varina", "coordinates": [-78.7858, 35.617] },
  { "markerOffset": 5, "name": "Holladay", "coordinates": [-111.8226, 40.6682] },
  { "markerOffset": 5, "name": "Upper Merion", "coordinates": [-75.3889, 40.1082] },
  { "markerOffset": 5, "name": "Los Gatos", "coordinates": [-121.9877, 37.2266] },
  { "markerOffset": 5, "name": "Saratoga", "coordinates": [-73.7437, 43.0831] },
  { "markerOffset": 5, "name": "Fortuna Foothills", "coordinates": [-114.154, 32.6579] },
  { "markerOffset": 5, "name": "Winona", "coordinates": [-91.6393, 44.0519] },
  { "markerOffset": 5, "name": "East Fishkill", "coordinates": [-73.7483, 41.551] },
  { "markerOffset": 5, "name": "SeaTac", "coordinates": [-122.2955, 47.4502] },
  { "markerOffset": 5, "name": "Niles", "coordinates": [-87.8028, 41.844] },
  { "markerOffset": 5, "name": "Big Spring", "coordinates": [-101.4636, 32.2504] },
  { "markerOffset": 5, "name": "Morrisville", "coordinates": [-74.5829, 40.2085] },
  { "markerOffset": 5, "name": "Plattsburgh", "coordinates": [-73.455, 44.6995] },
  { "markerOffset": 5, "name": "West Springfield", "coordinates": [-72.6405, 42.107] },
  { "markerOffset": 5, "name": "Monterey", "coordinates": [-121.8447, 36.6002] },
  { "markerOffset": 5, "name": "Sonora", "coordinates": [-120.3558, 37.9827] },
  { "markerOffset": 5, "name": "Yukon", "coordinates": [-97.7712, 35.5067] },
  { "markerOffset": 5, "name": "Wisconsin Rapids", "coordinates": [-89.8202, 44.3836] },
  { "markerOffset": 5, "name": "New Smyrna Beach", "coordinates": [-80.9014, 29.0258] },
  { "markerOffset": 5, "name": "East Chicago", "coordinates": [-87.4493, 41.6396] },
  { "markerOffset": 5, "name": "Morgan City", "coordinates": [-91.2098, 29.6994] },
  { "markerOffset": 5, "name": "Ramsey", "coordinates": [-74.1399, 40.8653] },
  { "markerOffset": 5, "name": "Canon City", "coordinates": [-105.2183, 38.4428] },
  { "markerOffset": 5, "name": "Queensbury", "coordinates": [-73.7154, 43.3481] },
  { "markerOffset": 5, "name": "Prior Lake", "coordinates": [-93.4336, 44.7133] },
  { "markerOffset": 5, "name": "Maple Valley", "coordinates": [-122.0431, 47.3668] },
  { "markerOffset": 5, "name": "Dodge City", "coordinates": [-100.0163, 37.752] },
  { "markerOffset": 5, "name": "McHenry", "coordinates": [-76.9378, 38.3311] },
  { "markerOffset": 5, "name": "Waterville", "coordinates": [-69.6507, 44.551] },
  { "markerOffset": 5, "name": "Shelby", "coordinates": [-81.5177, 35.2924] },
  { "markerOffset": 5, "name": "Ocean", "coordinates": [-74.075, 40.2485] },
  { "markerOffset": 5, "name": "Waynesboro", "coordinates": [-78.8836, 38.0685] },
  { "markerOffset": 5, "name": "Thomasville", "coordinates": [-83.9795, 30.8367] },
  { "markerOffset": 5, "name": "Marquette", "coordinates": [-87.6624, 46.5469] },
  { "markerOffset": 5, "name": "Sedalia", "coordinates": [-93.2283, 38.7044] },
  { "markerOffset": 5, "name": "Batavia", "coordinates": [-88.3126, 41.850] },
  { "markerOffset": 5, "name": "Cabot", "coordinates": [-92.0167, 34.9745] },
  { "markerOffset": 5, "name": "Neenah", "coordinates": [-88.4603, 44.1858] },
  { "markerOffset": 5, "name": "Lake City", "coordinates": [-82.6355, 30.1897] },
  { "markerOffset": 5, "name": "Boone", "coordinates": [-81.6745, 36.2168] },
  { "markerOffset": 5, "name": "Northport", "coordinates": [-87.5807, 33.253] },
  { "markerOffset": 5, "name": "Rock Springs", "coordinates": [-109.2215, 41.5875] },
  { "markerOffset": 5, "name": "Marshfield", "coordinates": [-90.1715, 44.6689] },
  { "markerOffset": 5, "name": "Pooler", "coordinates": [-81.2356, 32.115] },
  { "markerOffset": 5, "name": "Edgewood", "coordinates": [-76.2946, 39.4134] },
  { "markerOffset": 5, "name": "Sevierville", "coordinates": [-83.5618, 35.8681] },
  { "markerOffset": 5, "name": "Hudson", "coordinates": [-81.4407, 41.24] },
  { "markerOffset": 5, "name": "Bainbridge Island", "coordinates": [-122.535, 47.6279] },
  { "markerOffset": 5, "name": "Edwardsville", "coordinates": [-89.943, 38.8114] },
  { "markerOffset": 5, "name": "Yucca Valley", "coordinates": [-116.4322, 34.1144] },
  { "markerOffset": 5, "name": "Branson", "coordinates": [-93.2068, 36.6437] },
  { "markerOffset": 5, "name": "Wyandotte", "coordinates": [-83.1499, 42.2084] },
  { "markerOffset": 5, "name": "Kernersville", "coordinates": [-80.0825, 36.1199] },
  { "markerOffset": 5, "name": "Emporia", "coordinates": [-96.1817, 38.4044] },
  { "markerOffset": 5, "name": "Ellensburg", "coordinates": [-120.5463, 46.9965] },
  { "markerOffset": 5, "name": "Chantilly", "coordinates": [-77.4321, 38.8943] },
  { "markerOffset": 5, "name": "Ottumwa", "coordinates": [-92.4142, 41.0208] },
  { "markerOffset": 5, "name": "Ponca City", "coordinates": [-97.0856, 36.7069] },
  { "markerOffset": 5, "name": "Sun City Center", "coordinates": [-82.3655, 27.716] },
  { "markerOffset": 5, "name": "Simpsonville", "coordinates": [-82.2543, 34.7374] },
  { "markerOffset": 5, "name": "North Platte", "coordinates": [-100.7654, 41.1239] },
  { "markerOffset": 5, "name": "Fairfax", "coordinates": [-77.3064, 38.8462] },
  { "markerOffset": 5, "name": "Wadsworth", "coordinates": [-81.7214, 41.0256] },
  { "markerOffset": 5, "name": "Cranford", "coordinates": [-74.3032, 40.6563] },
  { "markerOffset": 5, "name": "Fort Dodge", "coordinates": [-94.1903, 42.4975] },
  { "markerOffset": 5, "name": "Palatka", "coordinates": [-81.6403, 29.6486] },
  { "markerOffset": 5, "name": "Waycross", "coordinates": [-82.318, 31.2136] },
  { "markerOffset": 5, "name": "Acton", "coordinates": [-118.2021, 34.4934] },
  { "markerOffset": 5, "name": "Zion", "coordinates": [-87.8431, 42.4462] },
  { "markerOffset": 5, "name": "Montrose", "coordinates": [-107.8635, 38.4784] },
  { "markerOffset": 5, "name": "Dickinson", "coordinates": [-102.7896, 29.4608] },
  { "markerOffset": 5, "name": "Plainsboro", "coordinates": [-74.549, 40.3327] },
  { "markerOffset": 5, "name": "Willoughby", "coordinates": [-81.4107, 41.6398] },
  { "markerOffset": 5, "name": "Gallup", "coordinates": [-108.7426, 35.5281] },
  { "markerOffset": 5, "name": "Acworth", "coordinates": [-84.6857, 34.0659] },
  { "markerOffset": 5, "name": "Barnegat", "coordinates": [-74.2248, 39.7596] },
  { "markerOffset": 5, "name": "Braidwood", "coordinates": [-88.2187, 41.2654] },
  { "markerOffset": 5, "name": "Meadville", "coordinates": [-80.1514, 41.6411] },
  { "markerOffset": 5, "name": "East Peoria", "coordinates": [-89.5667, 40.6669] },
  { "markerOffset": 5, "name": "Fort Walton Beach", "coordinates": [-86.6218, 30.4058] },
  { "markerOffset": 5, "name": "Christiansburg", "coordinates": [-80.4125, 37.1299] },
  { "markerOffset": 5, "name": "Warrensburg", "coordinates": [-93.7431, 38.7628] },
  { "markerOffset": 5, "name": "Sequim", "coordinates": [-123.152, 48.079] },
  { "markerOffset": 5, "name": "Katy", "coordinates": [-95.8245, 29.7858] },
  { "markerOffset": 5, "name": "Perrysburg", "coordinates": [-83.6272, 41.5564] },
  { "markerOffset": 5, "name": "Lewistown", "coordinates": [-90.1569, 40.3934] },
  { "markerOffset": 5, "name": "Somers", "coordinates": [-72.4618, 41.8412] },
  { "markerOffset": 5, "name": "Hays", "coordinates": [-99.1277, 38.8792] },
  { "markerOffset": 5, "name": "Palmer", "coordinates": [-149.1127, 61.6005] },
  { "markerOffset": 5, "name": "Owosso", "coordinates": [-84.1716, 42.9978] },
  { "markerOffset": 5, "name": "East Ridge", "coordinates": [-85.2163, 35.0141] },
  { "markerOffset": 5, "name": "Bonney Lake", "coordinates": [-122.168, 47.177] },
  { "markerOffset": 5, "name": "Kill Devil Hills", "coordinates": [-75.7069, 36.0307] },
  { "markerOffset": 5, "name": "Suwanee", "coordinates": [-84.0716, 34.0515] },
  { "markerOffset": 5, "name": "Green Valley", "coordinates": [-111.006, 31.8547] },
  { "markerOffset": 5, "name": "Dixon", "coordinates": [-121.8146, 38.4458] },
  { "markerOffset": 5, "name": "Havelock", "coordinates": [-76.9013, 34.9028] },
  { "markerOffset": 5, "name": "Lake Ronkonkoma", "coordinates": [-73.1294, 40.831] },
  { "markerOffset": 5, "name": "Yorkville", "coordinates": [-88.4422, 41.6412] },
  { "markerOffset": 5, "name": "The Dalles", "coordinates": [-121.183, 45.6016] },
  { "markerOffset": 5, "name": "Agoura Hills", "coordinates": [-118.7565, 34.1533] },
  { "markerOffset": 5, "name": "Rocky Hill", "coordinates": [-72.6603, 41.6862] },
  { "markerOffset": 5, "name": "Ypsilanti", "coordinates": [-83.6207, 42.2411] },
  { "markerOffset": 5, "name": "Pleasantville", "coordinates": [-74.4996, 39.3911] },
  { "markerOffset": 5, "name": "Tullahoma", "coordinates": [-86.2211, 35.362] },
  { "markerOffset": 5, "name": "Bourbonnais", "coordinates": [-87.8753, 41.1395] },
  { "markerOffset": 5, "name": "Sheridan", "coordinates": [-106.9744, 44.7978] },
  { "markerOffset": 5, "name": "Durant", "coordinates": [-96.3692, 33.9921] },
  { "markerOffset": 5, "name": "Corning", "coordinates": [-77.056, 42.1421] },
  { "markerOffset": 5, "name": "Pinole", "coordinates": [-122.276, 38.0044] },
  { "markerOffset": 5, "name": "Tiffin", "coordinates": [-83.1786, 41.1145] },
  { "markerOffset": 5, "name": "Westborough", "coordinates": [-71.6162, 42.2695] },
  { "markerOffset": 5, "name": "McAlester", "coordinates": [-95.7689, 34.9332] },
  { "markerOffset": 5, "name": "West Whiteland", "coordinates": [-75.6062, 40.026] },
  { "markerOffset": 5, "name": "Moultrie", "coordinates": [-83.7498, 31.1792] },
  { "markerOffset": 5, "name": "Lynden", "coordinates": [-122.4397, 48.9466] },
  { "markerOffset": 5, "name": "Hopkins", "coordinates": [-93.3746, 44.9248] },
  { "markerOffset": 5, "name": "Crawfordsville", "coordinates": [-86.8998, 40.0412] },
  { "markerOffset": 5, "name": "Beaver Dam", "coordinates": [-88.8375, 43.4578] },
  { "markerOffset": 5, "name": "Macomb", "coordinates": [-90.5148, 40.4592] },
  { "markerOffset": 5, "name": "Ocean Springs", "coordinates": [-88.8037, 30.4113] },
  { "markerOffset": 5, "name": "Wailuku", "coordinates": [-156.5041, 20.8895] },
  { "markerOffset": 5, "name": "Albert Lea", "coordinates": [-93.3643, 43.6476] },
  { "markerOffset": 5, "name": "Kirksville", "coordinates": [-92.5833, 40.1948] },
  { "markerOffset": 5, "name": "Clemson", "coordinates": [-82.8187, 34.6825] },
  { "markerOffset": 5, "name": "Vero Beach", "coordinates": [-80.3742, 27.6386] },
  { "markerOffset": 5, "name": "Martinsburg", "coordinates": [-77.9625, 39.4562] },
  { "markerOffset": 5, "name": "Doylestown", "coordinates": [-75.1299, 40.3101] },
  { "markerOffset": 5, "name": "Pendleton", "coordinates": [-118.7854, 45.6721] },
  { "markerOffset": 5, "name": "Willimantic", "coordinates": [-72.1995, 41.7107] },
  { "markerOffset": 5, "name": "Albemarle", "coordinates": [-80.2001, 35.3503] },
  { "markerOffset": 5, "name": "Yelm", "coordinates": [-122.605, 46.9412] },
  { "markerOffset": 5, "name": "Mountain Home", "coordinates": [-115.6341, 43.1327] },
  { "markerOffset": 5, "name": "Southbridge", "coordinates": [-72.0365, 42.0751] },
  { "markerOffset": 5, "name": "Bemidji", "coordinates": [-94.8851, 47.4781] },
  { "markerOffset": 5, "name": "Truckee", "coordinates": [-120.183, 39.3277] },
  { "markerOffset": 5, "name": "New Port Richey", "coordinates": [-82.7195, 28.2442] },
  { "markerOffset": 5, "name": "Auburndale", "coordinates": [-81.7966, 28.0723] },
  { "markerOffset": 5, "name": "Norcross", "coordinates": [-84.2124, 33.9412] },
  { "markerOffset": 5, "name": "Kings Park", "coordinates": [-73.2421, 40.8837] },
  { "markerOffset": 5, "name": "Fallon", "coordinates": [-118.7774, 39.4745] },
  { "markerOffset": 5, "name": "Conyers", "coordinates": [-84.0079, 33.6676] },
  { "markerOffset": 5, "name": "Stuart", "coordinates": [-80.2425, 27.1973] },
  { "markerOffset": 5, "name": "Wilmington Island", "coordinates": [-81.051, 32.0096] },
  { "markerOffset": 5, "name": "Elkton", "coordinates": [-75.818, 39.6018] },
  { "markerOffset": 5, "name": "South Fayette", "coordinates": [-80.1125, 40.3485] },
  { "markerOffset": 5, "name": "Buford", "coordinates": [-84.0038, 34.1209] },
  { "markerOffset": 5, "name": "Lake Geneva", "coordinates": [-88.4344, 42.5915] },
  { "markerOffset": 5, "name": "Grosse Pointe Woods", "coordinates": [-82.9071, 42.4408] },
  { "markerOffset": 5, "name": "Bradley", "coordinates": [-87.8363, 41.1421] },
  { "markerOffset": 5, "name": "Great Bend", "coordinates": [-98.7648, 38.3607] },
  { "markerOffset": 5, "name": "Susanville", "coordinates": [-120.6519, 40.4163] },
  { "markerOffset": 5, "name": "Tehachapi", "coordinates": [-118.4465, 35.1322] },
  { "markerOffset": 5, "name": "Astoria", "coordinates": [-123.8313, 46.1884] },
  { "markerOffset": 5, "name": "Alpine", "coordinates": [-116.777, 32.8351] },
  { "markerOffset": 5, "name": "Yankton", "coordinates": [-97.3975, 42.8713] },
  { "markerOffset": 5, "name": "California", "coordinates": [-76.620, 39.1609] },
  { "markerOffset": 5, "name": "Hartsville", "coordinates": [-80.0677, 34.374] },
  { "markerOffset": 5, "name": "Rincon", "coordinates": [-81.2356, 32.2966] },
  { "markerOffset": 5, "name": "New Paltz", "coordinates": [-74.0859, 41.743] },
  { "markerOffset": 5, "name": "Greensburg", "coordinates": [-79.537, 40.3015] },
  { "markerOffset": 5, "name": "Wixom", "coordinates": [-83.5346, 42.5248] },
  { "markerOffset": 5, "name": "Effingham", "coordinates": [-88.6057, 39.1205] },
  { "markerOffset": 5, "name": "Big Rapids", "coordinates": [-85.4837, 43.6981] },
  { "markerOffset": 5, "name": "Fulshear", "coordinates": [-95.865, 29.6932] },
  { "markerOffset": 5, "name": "Baraboo", "coordinates": [-89.7443, 43.4711] },
  { "markerOffset": 5, "name": "Fergus Falls", "coordinates": [-96.067, 46.283] },
  { "markerOffset": 5, "name": "Middlesex", "coordinates": [-74.5389, 40.5895] },
  { "markerOffset": 5, "name": "Brevard", "coordinates": [-82.7347, 35.2334] },
  { "markerOffset": 5, "name": "Alpena", "coordinates": [-83.4318, 45.0617] },
  { "markerOffset": 5, "name": "Elizabethton", "coordinates": [-82.1914, 36.3487] },
  { "markerOffset": 5, "name": "Jensen Beach", "coordinates": [-80.2417, 27.2545] },
  { "markerOffset": 5, "name": "South Park Township", "coordinates": [-79.9885, 40.3258] },
  { "markerOffset": 5, "name": "Moss Point", "coordinates": [-88.5336, 30.4278] },
  { "markerOffset": 5, "name": "Berkeley Heights", "coordinates": [-74.6454, 40.6752] },
  { "markerOffset": 5, "name": "Richton Park", "coordinates": [-87.6928, 41.4807] },
  { "markerOffset": 5, "name": "Woodinville", "coordinates": [-122.1501, 47.7543] },
  { "markerOffset": 5, "name": "Baker", "coordinates": [-89.4976, 30.5878] },
  { "markerOffset": 5, "name": "Spearfish", "coordinates": [-103.8607, 44.4908] },
  { "markerOffset": 5, "name": "Webb City", "coordinates": [-94.4779, 37.1558] },
  { "markerOffset": 5, "name": "Union Park", "coordinates": [-81.317, 28.5502] },
  { "markerOffset": 5, "name": "Moncks Corner", "coordinates": [-80.0097, 33.194] },
  { "markerOffset": 5, "name": "Cadillac", "coordinates": [-85.3995, 44.2519] },
  { "markerOffset": 5, "name": "Tomball", "coordinates": [-95.618, 30.0972] },
  { "markerOffset": 5, "name": "Putnam Valley", "coordinates": [-73.8072, 41.3454] },
  { "markerOffset": 5, "name": "Brattleboro", "coordinates": [-72.6659, 42.8504] },
  { "markerOffset": 5, "name": "Tega Cay", "coordinates": [-81.027, 35.0169] },
  { "markerOffset": 5, "name": "Satellite Beach", "coordinates": [-80.5883, 28.1761] },
  { "markerOffset": 5, "name": "Lexington Park", "coordinates": [-76.4549, 38.2642] },
  { "markerOffset": 5, "name": "Winnemucca", "coordinates": [-117.7357, 40.9732] },
  { "markerOffset": 5, "name": "Gig Harbor", "coordinates": [-122.5806, 47.3366] },
  { "markerOffset": 5, "name": "Ketchikan", "coordinates": [-131.6461, 55.3422] },
  { "markerOffset": 5, "name": "Cape Canaveral", "coordinates": [-80.6077, 28.4056] },
  { "markerOffset": 5, "name": "Bedford Heights", "coordinates": [-81.5047, 41.4041] },
  { "markerOffset": 5, "name": "Waynesville", "coordinates": [-82.9869, 35.4884] },
  { "markerOffset": 5, "name": "Tipp City", "coordinates": [-84.1736, 39.9584] },
  { "markerOffset": 5, "name": "Warrenton", "coordinates": [-77.8001, 38.7135] },
  { "markerOffset": 5, "name": "River Grove", "coordinates": [-87.8406, 41.9295] },
  { "markerOffset": 5, "name": "Cody", "coordinates": [-109.0565, 44.5263] },
  { "markerOffset": 5, "name": "North Bend", "coordinates": [-124.2243, 43.4065] },
  { "markerOffset": 5, "name": "East Rutherford", "coordinates": [-74.0673, 40.8339] },
  { "markerOffset": 5, "name": "Chevy Chase", "coordinates": [-77.0781, 38.9897] },
  { "markerOffset": 5, "name": "Wakefield-Peacedale", "coordinates": [-71.5103, 41.457] },
  { "markerOffset": 5, "name": "Airway Heights", "coordinates": [-117.5914, 47.6446] },
  { "markerOffset": 5, "name": "Manistee", "coordinates": [-86.2542, 44.2489] },
  { "markerOffset": 5, "name": "Bay Minette", "coordinates": [-87.773, 30.8821] },
  { "markerOffset": 5, "name": "Birch Bay", "coordinates": [-122.7616, 48.9226] },
  { "markerOffset": 5, "name": "Beckett Ridge", "coordinates": [-84.3325, 39.3504] },
  { "markerOffset": 5, "name": "Presque Isle", "coordinates": [-68.0126, 46.6814] },
  { "markerOffset": 5, "name": "Mechanicsburg", "coordinates": [-77.0044, 40.2147] },
  { "markerOffset": 5, "name": "Sellersburg", "coordinates": [-85.7578, 38.3988] },
  { "markerOffset": 5, "name": "Kodiak", "coordinates": [-152.4044, 57.79] },
  { "markerOffset": 5, "name": "Rhinelander", "coordinates": [-89.4121, 45.6366] },
  { "markerOffset": 5, "name": "Sitka", "coordinates": [-135.3305, 57.0531] },
  { "markerOffset": 5, "name": "Gaylord", "coordinates": [-84.679, 45.0275] },
  { "markerOffset": 5, "name": "Petoskey", "coordinates": [-84.9916, 45.3769] },
  { "markerOffset": 5, "name": "Ellsworth", "coordinates": [-68.6626, 44.5453] },
  { "markerOffset": 5, "name": "Port Jefferson", "coordinates": [-73.0699, 40.9465] },
  { "markerOffset": 5, "name": "Vandenberg Village", "coordinates": [-120.455, 34.7] },
  { "markerOffset": 5, "name": "Monument", "coordinates": [-104.872, 39.0917] },
  { "markerOffset": 5, "name": "Menominee", "coordinates": [-87.6284, 45.1078] },
  { "markerOffset": 5, "name": "Downingtown", "coordinates": [-75.7038, 40.0065] },
  { "markerOffset": 5, "name": "DeFuniak Springs", "coordinates": [-86.1216, 30.7211] },
  { "markerOffset": 5, "name": "Forsyth", "coordinates": [-83.9415, 33.0387] },
  { "markerOffset": 5, "name": "Fort Scott", "coordinates": [-94.7083, 37.8392] },
  { "markerOffset": 5, "name": "Pukalani", "coordinates": [-156.325, 20.8296] },
  { "markerOffset": 5, "name": "Yreka", "coordinates": [-122.6376, 41.7354] },
  { "markerOffset": 5, "name": "Ojai", "coordinates": [-119.2932, 34.448] },
  { "markerOffset": 5, "name": "Le Roy", "coordinates": [-77.9872, 42.977] },
  { "markerOffset": 5, "name": "North Springfield", "coordinates": [-72.5575, 42.8443] },
  { "markerOffset": 5, "name": "Baywood", "coordinates": [-77.9801, 37.3196] },
  { "markerOffset": 5, "name": "Moab", "coordinates": [-109.5506, 38.5739] },
  { "markerOffset": 5, "name": "Lihue", "coordinates": [-159.365, 21.9816] },
  { "markerOffset": 5, "name": "Fowler", "coordinates": [-119.6706, 36.6332] },
  { "markerOffset": 5, "name": "Stone Mountain", "coordinates": [-84.1707, 33.8053] },
  { "markerOffset": 5, "name": "North East", "coordinates": [-75.9466, 39.6002] },
  { "markerOffset": 5, "name": "Huntington Woods", "coordinates": [-83.1812, 42.4841] },
  { "markerOffset": 5, "name": "Chelan", "coordinates": [-120.0269, 47.8378] },
  { "markerOffset": 5, "name": "Pontotoc", "coordinates": [-89.0177, 34.2558] },
  { "markerOffset": 5, "name": "Brownville", "coordinates": [-70.5257, 45.3612] },
  { "markerOffset": 5, "name": "Pagosa Springs", "coordinates": [-107.0068, 37.2692] },
  { "markerOffset": 5, "name": "Hilton", "coordinates": [-77.811, 43.2203] },
  { "markerOffset": 5, "name": "Flanders", "coordinates": [-74.2212, 40.8476] },
  { "markerOffset": 5, "name": "Wrightsville", "coordinates": [-76.7233, 39.9356] },
  { "markerOffset": 5, "name": "Bulverde", "coordinates": [-98.4521, 29.7457] },
  { "markerOffset": 5, "name": "Iola", "coordinates": [-95.4023, 37.9232] }
];

const filteredMarkers = [];

const offsets = {
  VT: [50, -8],
  NH: [34, 2],
  MA: [30, -1],
  RI: [28, 2],
  CT: [35, 10],
  NJ: [34, 1],
  DE: [33, 0],
  MD: [47, 10],
  DC: [49, 21]
};

function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in kilometers
  return distance;
}

// Function to convert degrees to radians
function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

const States = () => {
  const [alphaValues, setAlphaValues] = useState({});

  const updateAlphaValue = (stateName, alpha) => {
    if (alphaValues[stateName] != null) {
      setAlphaValues((prevValues) => ({
        ...prevValues, [stateName]: alpha
      }));
    } else {
      alphaValues[stateName] = alpha;
    }
  };

  useEffect(() => {
    fetch(geoUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        data.objects.states.geometries.forEach(geometry => {
          updateAlphaValue(geometry.properties.name, 0);
        });
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
      });

      markers.forEach(({ markerOffset, name, coordinates }) => {
        let spawnCity = true;
        filteredMarkers.forEach(({ name: name2, coordinates: coordinates2 }) => {
            if (name === name2) return;
            if (calculateDistance(coordinates[1], coordinates[0], coordinates2[1], coordinates2[0]) < 10) {
                spawnCity = false;
            }
        });
    
        if (spawnCity) {
          filteredMarkers.push({"markerOffset": markerOffset, "name": name, "coordinates": coordinates});
        }
    });
    

    window.setAlphaValues = setAlphaValues;
    window.updateAlphaValue = updateAlphaValue;
    window.alphaValues = alphaValues;
    window.filteredMarkers = filteredMarkers;
  }, []);

  return (
    <ComposableMap projection="geoAlbersUsa">
      <ZoomableGroup center={[0, 0]} zoom={1} translateExtent={[[-50, -50], [2000, 1600]]}>
        <Geographies geography={geoUrl}>
          {({ geographies }) => (
            <>
              {geographies.map(geo => (
                <Geography
                  key={geo.rsmKey}
                  stroke="#FFF"
                  geography={geo}
                  fill={`rgb(42,53,77,${(alphaValues[geo.properties.name] * .8) + .2})`}
                  style={{
                    default: { outline: "none" },
                    hover: { outline: "none" },
                    pressed: { outline: "none" },
                  }}>
                  <title>{geo.properties.name}</title>
                </Geography>
              ))}
            </>
          )}
        </Geographies>
        {filteredMarkers.map(({ name, coordinates, markerOffset }) => (
          <Marker key={name} coordinates={coordinates}>
            <circle r={1} fill="#000000" strokeWidth={1} />
            <title>{name}</title>
          </Marker>
        ))}
      </ZoomableGroup>
    </ComposableMap>
  );
};

export default States;
